import { A as xo, C as k, D as q, E as So, N as fr, O as Co, S as B, T as _o, a as Ro, g as z, h as pr, k as Eo, m as ae, n as vt, o as Po, r as Z, s as de, t as mr, v as be, w as jo, x as ie, y as hr } from "./base-DpxiM7W9.mjs.js";
import { _ as ko, a as wt, b as No, d as To, g as Ao, h as Io, l as Do, m as Oo, o as $o, p as Mo, s as Lo, t as Fo, u as Bo, v as zo, x as fe, y as Uo } from "./recentSearches-PRg0o-NF.mjs.js";
import { a as gr, c as Vo, d as Ne, f as qo, i as Ue, l as bt, m as Ho, n as Wo, o as Ve, p as yt, r as xt, s as qe, t as Ko, u as Jt } from "./productCarousel-X6A_OGUI.mjs.js";
var St = Co();
function Go(e) {
  return e?.length ? e.reduce((t, r) => (r.values?.length && (r.values.length === 1 ? t[r.name] = r.values[0].value : t[r.name] = r.values.map((n) => n.value)), t), {}) : {};
}
function Yo(e, t) {
  return e ? Object.entries(e).filter(([, r]) => r != null && r !== "").map(([r, n]) => {
    const a = t?.find((c) => c.name === r), o = a?.options, s = Array.isArray(n) ? n.map((c) => ({
      value: c,
      display_name: o?.find((d) => d.value === c)?.display_name
    })) : [{
      value: n,
      display_name: o?.find((c) => c.value === n)?.display_name
    }];
    return {
      name: r,
      display_name: a?.display_name ?? r,
      type: a?.type ?? "multiple",
      values: s
    };
  }) : [];
}
var l = /* @__PURE__ */ fr(xo(), 1), i = _o(), Xo = /* @__PURE__ */ Symbol.for("react.lazy"), Fe = l[" use ".trim().toString()];
function Jo(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
function vr(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === Xo && "_payload" in e && Jo(e._payload);
}
// @__NO_SIDE_EFFECTS__
function wr(e) {
  const t = /* @__PURE__ */ Zo(e), r = l.forwardRef((n, a) => {
    let { children: o, ...s } = n;
    vr(o) && typeof Fe == "function" && (o = Fe(o._payload));
    const c = l.Children.toArray(o), d = c.find(ta);
    if (d) {
      const f = d.props.children, u = c.map((p) => p === d ? l.Children.count(f) > 1 ? l.Children.only(null) : l.isValidElement(f) ? f.props.children : null : p);
      return /* @__PURE__ */ (0, i.jsx)(t, {
        ...s,
        ref: a,
        children: l.isValidElement(f) ? l.cloneElement(f, void 0, u) : null
      });
    }
    return /* @__PURE__ */ (0, i.jsx)(t, {
      ...s,
      ref: a,
      children: o
    });
  });
  return r.displayName = `${e}.Slot`, r;
}
var Qo = /* @__PURE__ */ wr("Slot");
// @__NO_SIDE_EFFECTS__
function Zo(e) {
  const t = l.forwardRef((r, n) => {
    let { children: a, ...o } = r;
    if (vr(a) && typeof Fe == "function" && (a = Fe(a._payload)), l.isValidElement(a)) {
      const s = na(a), c = ra(o, a.props);
      return a.type !== l.Fragment && (c.ref = n ? So(n, s) : s), l.cloneElement(a, c);
    }
    return l.Children.count(a) > 1 ? l.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var ea = /* @__PURE__ */ Symbol("radix.slottable");
function ta(e) {
  return l.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === ea;
}
function ra(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = {
      ...a,
      ...o
    } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...r
  };
}
function na(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var br = jo("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", {
  variants: {
    variant: {
      default: "bg-primary text-white hover:bg-primary/90",
      destructive: "bg-destructive text-white hover:bg-destructive/90 focus-visible:ring-destructive/20",
      outline: "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground",
      secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
      ghost: "hover:bg-accent hover:text-accent-foreground",
      link: "text-primary underline-offset-4 hover:underline"
    },
    size: {
      default: "h-9 px-4 py-2 has-[>svg]:px-3",
      sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
      lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
      icon: "size-9"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
});
function yr({ className: e, variant: t, size: r, asChild: n = !1, ...a }) {
  return /* @__PURE__ */ (0, i.jsx)(n ? Qo : "button", {
    "data-slot": "button",
    className: k(br({
      variant: t,
      size: r,
      className: e
    })),
    ...a
  });
}
var He = "Collapsible", [oa, _l] = ie(He), [aa, Ct] = oa(He), xr = l.forwardRef((e, t) => {
  const { __scopeCollapsible: r, open: n, defaultOpen: a, disabled: o, onOpenChange: s, ...c } = e, [d, f] = be({
    prop: n,
    defaultProp: a ?? !1,
    onChange: s,
    caller: He
  });
  return /* @__PURE__ */ (0, i.jsx)(aa, {
    scope: r,
    disabled: o,
    contentId: pr(),
    open: d,
    onOpenToggle: l.useCallback(() => f((u) => !u), [f]),
    children: /* @__PURE__ */ (0, i.jsx)(z.div, {
      "data-state": Rt(d),
      "data-disabled": o ? "" : void 0,
      ...c,
      ref: t
    })
  });
});
xr.displayName = He;
var Sr = "CollapsibleTrigger", Cr = l.forwardRef((e, t) => {
  const { __scopeCollapsible: r, ...n } = e, a = Ct(Sr, r);
  return /* @__PURE__ */ (0, i.jsx)(z.button, {
    type: "button",
    "aria-controls": a.contentId,
    "aria-expanded": a.open || !1,
    "data-state": Rt(a.open),
    "data-disabled": a.disabled ? "" : void 0,
    disabled: a.disabled,
    ...n,
    ref: t,
    onClick: B(e.onClick, a.onOpenToggle)
  });
});
Cr.displayName = Sr;
var _t = "CollapsibleContent", _r = l.forwardRef((e, t) => {
  const { forceMount: r, ...n } = e, a = Ct(_t, e.__scopeCollapsible);
  return /* @__PURE__ */ (0, i.jsx)(fe, {
    present: r || a.open,
    children: ({ present: o }) => /* @__PURE__ */ (0, i.jsx)(sa, {
      ...n,
      ref: t,
      present: o
    })
  });
});
_r.displayName = _t;
var sa = l.forwardRef((e, t) => {
  const { __scopeCollapsible: r, present: n, children: a, ...o } = e, s = Ct(_t, r), [c, d] = l.useState(n), f = l.useRef(null), u = q(t, f), p = l.useRef(0), m = p.current, h = l.useRef(0), b = h.current, y = s.open || c, w = l.useRef(y), g = l.useRef(void 0);
  return l.useEffect(() => {
    const v = requestAnimationFrame(() => w.current = !1);
    return () => cancelAnimationFrame(v);
  }, []), hr(() => {
    const v = f.current;
    if (v) {
      g.current = g.current || {
        transitionDuration: v.style.transitionDuration,
        animationName: v.style.animationName
      }, v.style.transitionDuration = "0s", v.style.animationName = "none";
      const x = v.getBoundingClientRect();
      p.current = x.height, h.current = x.width, w.current || (v.style.transitionDuration = g.current.transitionDuration, v.style.animationName = g.current.animationName), d(n);
    }
  }, [s.open, n]), /* @__PURE__ */ (0, i.jsx)(z.div, {
    "data-state": Rt(s.open),
    "data-disabled": s.disabled ? "" : void 0,
    id: s.contentId,
    hidden: !y,
    ...o,
    ref: u,
    style: {
      "--radix-collapsible-content-height": m ? `${m}px` : void 0,
      "--radix-collapsible-content-width": b ? `${b}px` : void 0,
      ...e.style
    },
    children: y && a
  });
});
function Rt(e) {
  return e ? "open" : "closed";
}
var ia = xr;
function Rr({ ...e }) {
  return /* @__PURE__ */ (0, i.jsx)(ia, {
    "data-slot": "collapsible",
    ...e
  });
}
function Er({ ...e }) {
  return /* @__PURE__ */ (0, i.jsx)(Cr, {
    "data-slot": "collapsible-trigger",
    ...e
  });
}
function Pr({ className: e, ...t }) {
  return /* @__PURE__ */ (0, i.jsx)(_r, {
    "data-slot": "collapsible-content",
    className: k("data-[state=closed]:animate-collapsible-up data-[state=closed]:h-0", "overflow-hidden data-[state=open]:animate-collapsible-down", e),
    ...t
  });
}
function la(e) {
  if (!e || typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
  r.type = "text/css", t.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
}
var jr = l.createContext({
  drawerRef: { current: null },
  overlayRef: { current: null },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: { current: !1 },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: { current: !0 },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), ye = () => {
  const e = l.useContext(jr);
  if (!e) throw new Error("useDrawerContext must be used within a Drawer.Root");
  return e;
};
la(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function ca() {
  const e = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(e) && /Mobile/.test(e) || /FxiOS/.test(e));
}
function ua() {
  return Et(/^Mac/);
}
function da() {
  return Et(/^iPhone/);
}
function Qt() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function fa() {
  return Et(/^iPad/) || ua() && navigator.maxTouchPoints > 1;
}
function kr() {
  return da() || fa();
}
function Et(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
var pa = 24, ma = typeof window < "u" ? l.useLayoutEffect : l.useEffect;
function Zt(...e) {
  return (...t) => {
    for (let r of e) typeof r == "function" && r(...t);
  };
}
var ot = typeof document < "u" && window.visualViewport;
function er(e) {
  let t = window.getComputedStyle(e);
  return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
}
function Nr(e) {
  for (er(e) && (e = e.parentElement); e && !er(e); ) e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
var ha = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]), Oe = 0, tr;
function ga(e = {}) {
  let { isDisabled: t } = e;
  ma(() => {
    if (!t)
      return Oe++, Oe === 1 && kr() && (tr = va()), () => {
        Oe--, Oe === 0 && tr?.();
      };
  }, [t]);
}
function va() {
  let e, t = 0, r = (p) => {
    e = Nr(p.target), !(e === document.documentElement && e === document.body) && (t = p.changedTouches[0].pageY);
  }, n = (p) => {
    if (!e || e === document.documentElement || e === document.body) {
      p.preventDefault();
      return;
    }
    let m = p.changedTouches[0].pageY, h = e.scrollTop, b = e.scrollHeight - e.clientHeight;
    b !== 0 && ((h <= 0 && m > t || h >= b && m < t) && p.preventDefault(), t = m);
  }, a = (p) => {
    let m = p.target;
    ut(m) && m !== document.activeElement && (p.preventDefault(), m.style.transform = "translateY(-2000px)", m.focus(), requestAnimationFrame(() => {
      m.style.transform = "";
    }));
  }, o = (p) => {
    let m = p.target;
    ut(m) && (m.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      m.style.transform = "", ot && (ot.height < window.innerHeight ? requestAnimationFrame(() => {
        rr(m);
      }) : ot.addEventListener("resize", () => rr(m), { once: !0 }));
    }));
  }, s = () => {
    window.scrollTo(0, 0);
  }, c = window.pageXOffset, d = window.pageYOffset, f = Zt(wa(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let u = Zt(Ee(document, "touchstart", r, {
    passive: !1,
    capture: !0
  }), Ee(document, "touchmove", n, {
    passive: !1,
    capture: !0
  }), Ee(document, "touchend", a, {
    passive: !1,
    capture: !0
  }), Ee(document, "focus", o, !0), Ee(window, "scroll", s));
  return () => {
    f(), u(), window.scrollTo(c, d);
  };
}
function wa(e, t, r) {
  let n = e.style[t];
  return e.style[t] = r, () => {
    e.style[t] = n;
  };
}
function Ee(e, t, r, n) {
  return e.addEventListener(t, r, n), () => {
    e.removeEventListener(t, r, n);
  };
}
function rr(e) {
  let t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    let r = Nr(e);
    if (r !== document.documentElement && r !== document.body && r !== e) {
      let n = r.getBoundingClientRect().top, a = e.getBoundingClientRect().top;
      e.getBoundingClientRect().bottom > r.getBoundingClientRect().bottom + pa && (r.scrollTop += a - n);
    }
    e = r.parentElement;
  }
}
function ut(e) {
  return e instanceof HTMLInputElement && !ha.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function ba(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function ya(...e) {
  return (t) => e.forEach((r) => ba(r, t));
}
function Tr(...e) {
  return l.useCallback(ya(...e), e);
}
var Ar = /* @__PURE__ */ new WeakMap();
function K(e, t, r = !1) {
  if (!e || !(e instanceof HTMLElement)) return;
  let n = {};
  Object.entries(t).forEach(([a, o]) => {
    if (a.startsWith("--")) {
      e.style.setProperty(a, o);
      return;
    }
    n[a] = e.style[a], e.style[a] = o;
  }), !r && Ar.set(e, n);
}
function xa(e, t) {
  if (!e || !(e instanceof HTMLElement)) return;
  let r = Ar.get(e);
  r && (e.style[t] = r[t]);
}
var W = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function $e(e, t) {
  if (!e) return null;
  const r = window.getComputedStyle(e), n = r.transform || r.webkitTransform || r.mozTransform;
  let a = n.match(/^matrix3d\((.+)\)$/);
  return a ? parseFloat(a[1].split(", ")[W(t) ? 13 : 12]) : (a = n.match(/^matrix\((.+)\)$/), a ? parseFloat(a[1].split(", ")[W(t) ? 5 : 4]) : null);
}
function Sa(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function at(e, t) {
  if (!e) return () => {
  };
  const r = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = r;
  };
}
function Ca(...e) {
  return (...t) => {
    for (const r of e) typeof r == "function" && r(...t);
  };
}
var U = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, Ir = 0.4, _a = 0.25, Ra = 100, Dr = 8, ue = 16, dt = 26, st = "vaul-dragging";
function Or(e) {
  const t = l.useRef(e);
  return l.useEffect(() => {
    t.current = e;
  }), l.useMemo(() => (...r) => t.current == null ? void 0 : t.current.call(t, ...r), []);
}
function Ea({ defaultProp: e, onChange: t }) {
  const r = l.useState(e), [n] = r, a = l.useRef(n), o = Or(t);
  return l.useEffect(() => {
    a.current !== n && (o(n), a.current = n);
  }, [
    n,
    a,
    o
  ]), r;
}
function $r({ prop: e, defaultProp: t, onChange: r = () => {
} }) {
  const [n, a] = Ea({
    defaultProp: t,
    onChange: r
  }), o = e !== void 0, s = o ? e : n, c = Or(r);
  return [s, l.useCallback((d) => {
    if (o) {
      const f = typeof d == "function" ? d(e) : d;
      f !== e && c(f);
    } else a(d);
  }, [
    o,
    e,
    a,
    c
  ])];
}
function Pa({ activeSnapPointProp: e, setActiveSnapPointProp: t, snapPoints: r, drawerRef: n, overlayRef: a, fadeFromIndex: o, onSnapPointChange: s, direction: c = "bottom", container: d, snapToSequentialPoint: f }) {
  const [u, p] = $r({
    prop: e,
    defaultProp: r?.[0],
    onChange: t
  }), [m, h] = l.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  l.useEffect(() => {
    function _() {
      h({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", _), () => window.removeEventListener("resize", _);
  }, []);
  const b = l.useMemo(() => u === r?.[r.length - 1] || null, [r, u]), y = l.useMemo(() => {
    var _;
    return (_ = r?.findIndex((C) => C === u)) != null ? _ : null;
  }, [r, u]), w = r && r.length > 0 && (o || o === 0) && !Number.isNaN(o) && r[o] === u || !r, g = l.useMemo(() => {
    const _ = d ? {
      width: d.getBoundingClientRect().width,
      height: d.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var C;
    return (C = r?.map((R) => {
      const P = typeof R == "string";
      let M = 0;
      if (P && (M = parseInt(R, 10)), W(c)) {
        const E = P ? M : m ? R * _.height : 0;
        return m ? c === "bottom" ? _.height - E : -_.height + E : E;
      }
      const T = P ? M : m ? R * _.width : 0;
      return m ? c === "right" ? _.width - T : -_.width + T : T;
    })) != null ? C : [];
  }, [
    r,
    m,
    d
  ]), v = l.useMemo(() => y !== null ? g?.[y] : null, [g, y]), x = l.useCallback((_) => {
    var C;
    const R = (C = g?.findIndex((P) => P === _)) != null ? C : null;
    s(R), K(n.current, {
      transition: `transform ${U.DURATION}s cubic-bezier(${U.EASE.join(",")})`,
      transform: W(c) ? `translate3d(0, ${_}px, 0)` : `translate3d(${_}px, 0, 0)`
    }), g && R !== g.length - 1 && o !== void 0 && R !== o && R < o ? K(a.current, {
      transition: `opacity ${U.DURATION}s cubic-bezier(${U.EASE.join(",")})`,
      opacity: "0"
    }) : K(a.current, {
      transition: `opacity ${U.DURATION}s cubic-bezier(${U.EASE.join(",")})`,
      opacity: "1"
    }), p(r?.[Math.max(R, 0)]);
  }, [
    n.current,
    r,
    g,
    o,
    a,
    p
  ]);
  l.useEffect(() => {
    if (u || e) {
      var _;
      const C = (_ = r?.findIndex((R) => R === e || R === u)) != null ? _ : -1;
      g && C !== -1 && typeof g[C] == "number" && x(g[C]);
    }
  }, [
    u,
    e,
    r,
    g,
    x
  ]);
  function S({ draggedDistance: _, closeDrawer: C, velocity: R, dismissible: P }) {
    if (o === void 0) return;
    const M = c === "bottom" || c === "right" ? (v ?? 0) - _ : (v ?? 0) + _, T = y === o - 1, E = y === 0, $ = _ > 0;
    if (T && K(a.current, { transition: `opacity ${U.DURATION}s cubic-bezier(${U.EASE.join(",")})` }), !f && R > 2 && !$) {
      P ? C() : x(g[0]);
      return;
    }
    if (!f && R > 2 && $ && g && r) {
      x(g[r.length - 1]);
      return;
    }
    const L = g?.reduce((G, re) => typeof G != "number" || typeof re != "number" ? G : Math.abs(re - M) < Math.abs(G - M) ? re : G), H = W(c) ? window.innerHeight : window.innerWidth;
    if (R > Ir && Math.abs(_) < H * 0.4) {
      const G = $ ? 1 : -1;
      if (G > 0 && b && r) {
        x(g[r.length - 1]);
        return;
      }
      if (E && G < 0 && P && C(), y === null) return;
      x(g[y + G]);
      return;
    }
    x(L);
  }
  function D({ draggedDistance: _ }) {
    if (v === null) return;
    const C = c === "bottom" || c === "right" ? v - _ : v + _;
    (c === "bottom" || c === "right") && C < g[g.length - 1] || (c === "top" || c === "left") && C > g[g.length - 1] || K(n.current, { transform: W(c) ? `translate3d(0, ${C}px, 0)` : `translate3d(${C}px, 0, 0)` });
  }
  function N(_, C) {
    if (!r || typeof y != "number" || !g || o === void 0) return null;
    const R = y === o - 1;
    if (y >= o && C) return 0;
    if (R && !C) return 1;
    if (!w && !R) return null;
    const P = R ? y + 1 : y - 1, M = R ? g[P] - g[P - 1] : g[P + 1] - g[P], T = _ / Math.abs(M);
    return R ? 1 - T : T;
  }
  return {
    isLastSnapPoint: b,
    activeSnapPoint: u,
    shouldFade: w,
    getPercentageDragged: N,
    setActiveSnapPoint: p,
    activeSnapPointIndex: y,
    onRelease: S,
    onDrag: D,
    snapPointsOffset: g
  };
}
var ja = () => () => {
};
function ka() {
  const { direction: e, isOpen: t, shouldScaleBackground: r, setBackgroundColorOnScale: n, noBodyStyles: a } = ye(), o = l.useRef(null), s = (0, l.useMemo)(() => document.body.style.backgroundColor, []);
  function c() {
    return (window.innerWidth - dt) / window.innerWidth;
  }
  l.useEffect(() => {
    if (t && r) {
      o.current && clearTimeout(o.current);
      const d = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!d) return;
      Ca(n && !a ? at(document.body, { background: "black" }) : ja, at(d, {
        transformOrigin: W(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${U.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${U.EASE.join(",")})`
      }));
      const f = at(d, {
        borderRadius: `${Dr}px`,
        overflow: "hidden",
        ...W(e) ? { transform: `scale(${c()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)` } : { transform: `scale(${c()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)` }
      });
      return () => {
        f(), o.current = window.setTimeout(() => {
          s ? document.body.style.background = s : document.body.style.removeProperty("background");
        }, U.DURATION * 1e3);
      };
    }
  }, [
    t,
    r,
    s
  ]);
}
var Pe = null;
function Na({ isOpen: e, modal: t, nested: r, hasBeenOpened: n, preventScrollRestoration: a, noBodyStyles: o }) {
  const [s, c] = l.useState(() => typeof window < "u" ? window.location.href : ""), d = l.useRef(0), f = l.useCallback(() => {
    if (Qt() && Pe === null && e && !o) {
      Pe = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: p, innerHeight: m } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-d.current}px`,
        left: `${-p}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const h = m - window.innerHeight;
        h && d.current >= m && (document.body.style.top = `${-(d.current + h)}px`);
      }), 300);
    }
  }, [e]), u = l.useCallback(() => {
    if (Qt() && Pe !== null && !o) {
      const p = -parseInt(document.body.style.top, 10), m = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, Pe), window.requestAnimationFrame(() => {
        if (a && s !== window.location.href) {
          c(window.location.href);
          return;
        }
        window.scrollTo(m, p);
      }), Pe = null;
    }
  }, [s]);
  return l.useEffect(() => {
    function p() {
      d.current = window.scrollY;
    }
    return p(), window.addEventListener("scroll", p), () => {
      window.removeEventListener("scroll", p);
    };
  }, []), l.useEffect(() => {
    if (t)
      return () => {
        typeof document > "u" || document.querySelector("[data-vaul-drawer]") || u();
      };
  }, [t, u]), l.useEffect(() => {
    r || !n || (e ? (!window.matchMedia("(display-mode: standalone)").matches && f(), t || window.setTimeout(() => {
      u();
    }, 500)) : u());
  }, [
    e,
    n,
    s,
    t,
    r,
    f,
    u
  ]), { restorePositionSetting: u };
}
function Mr({ open: e, onOpenChange: t, children: r, onDrag: n, onRelease: a, snapPoints: o, shouldScaleBackground: s = !1, setBackgroundColorOnScale: c = !0, closeThreshold: d = _a, scrollLockTimeout: f = Ra, dismissible: u = !0, handleOnly: p = !1, fadeFromIndex: m = o && o.length - 1, activeSnapPoint: h, setActiveSnapPoint: b, fixed: y, modal: w = !0, onClose: g, nested: v, noBodyStyles: x = !1, direction: S = "bottom", defaultOpen: D = !1, disablePreventScroll: N = !0, snapToSequentialPoint: _ = !1, preventScrollRestoration: C = !1, repositionInputs: R = !0, onAnimationEnd: P, container: M, autoFocus: T = !1 }) {
  var E, $;
  const [L = !1, H] = $r({
    defaultProp: D,
    prop: e,
    onChange: (j) => {
      t?.(j), !j && !v && po(), setTimeout(() => {
        P?.(j);
      }, U.DURATION * 1e3), j && !w && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), j || (document.body.style.pointerEvents = "auto");
    }
  }), [G, re] = l.useState(!1), [ne, Qe] = l.useState(!1), [io, zt] = l.useState(!1), pe = l.useRef(null), Ae = l.useRef(null), Ze = l.useRef(null), et = l.useRef(null), Se = l.useRef(null), Ce = l.useRef(!1), tt = l.useRef(null), rt = l.useRef(0), me = l.useRef(!1), Ut = l.useRef(!D), Vt = l.useRef(0), A = l.useRef(null), qt = l.useRef(((E = A.current) == null ? void 0 : E.getBoundingClientRect().height) || 0), Ht = l.useRef((($ = A.current) == null ? void 0 : $.getBoundingClientRect().width) || 0), nt = l.useRef(0), { activeSnapPoint: lo, activeSnapPointIndex: he, setActiveSnapPoint: Wt, onRelease: co, snapPointsOffset: _e, onDrag: uo, shouldFade: Kt, getPercentageDragged: fo } = Pa({
    snapPoints: o,
    activeSnapPointProp: h,
    setActiveSnapPointProp: b,
    drawerRef: A,
    fadeFromIndex: m,
    overlayRef: pe,
    onSnapPointChange: l.useCallback((j) => {
      o && j === _e.length - 1 && (Ae.current = /* @__PURE__ */ new Date());
    }, []),
    direction: S,
    container: M,
    snapToSequentialPoint: _
  });
  ga({ isDisabled: !L || ne || !w || io || !G || !R || !N });
  const { restorePositionSetting: po } = Na({
    isOpen: L,
    modal: w,
    nested: v ?? !1,
    hasBeenOpened: G,
    preventScrollRestoration: C,
    noBodyStyles: x
  });
  function Ie() {
    return (window.innerWidth - dt) / window.innerWidth;
  }
  function mo(j) {
    var O, F;
    !u && !o || A.current && !A.current.contains(j.target) || (qt.current = ((O = A.current) == null ? void 0 : O.getBoundingClientRect().height) || 0, Ht.current = ((F = A.current) == null ? void 0 : F.getBoundingClientRect().width) || 0, Qe(!0), Ze.current = /* @__PURE__ */ new Date(), kr() && window.addEventListener("touchend", () => Ce.current = !1, { once: !0 }), j.target.setPointerCapture(j.pointerId), rt.current = W(S) ? j.pageY : j.pageX);
  }
  function Gt(j, O) {
    var F;
    let I = j;
    const V = (F = window.getSelection()) == null ? void 0 : F.toString(), X = A.current ? $e(A.current, S) : null, Y = /* @__PURE__ */ new Date();
    if (I.tagName === "SELECT" || I.hasAttribute("data-vaul-no-drag") || I.closest("[data-vaul-no-drag]")) return !1;
    if (S === "right" || S === "left") return !0;
    if (Ae.current && Y.getTime() - Ae.current.getTime() < 500) return !1;
    if (X !== null && (S === "bottom" ? X > 0 : X < 0))
      return !0;
    if (V && V.length > 0) return !1;
    if (Se.current && Y.getTime() - Se.current.getTime() < f && X === 0 || O)
      return Se.current = Y, !1;
    for (; I; ) {
      if (I.scrollHeight > I.clientHeight) {
        if (I.scrollTop !== 0)
          return Se.current = /* @__PURE__ */ new Date(), !1;
        if (I.getAttribute("role") === "dialog") return !0;
      }
      I = I.parentNode;
    }
    return !0;
  }
  function ho(j) {
    if (A.current && ne) {
      const O = S === "bottom" || S === "right" ? 1 : -1, F = (rt.current - (W(S) ? j.pageY : j.pageX)) * O, I = F > 0, V = o && !u && !I;
      if (V && he === 0) return;
      const X = Math.abs(F), Y = document.querySelector("[data-vaul-drawer-wrapper]");
      let J = X / (S === "bottom" || S === "top" ? qt.current : Ht.current);
      const ge = fo(X, I);
      if (ge !== null && (J = ge), V && J >= 1 || !Ce.current && !Gt(j.target, I)) return;
      if (A.current.classList.add(st), Ce.current = !0, K(A.current, { transition: "none" }), K(pe.current, { transition: "none" }), o && uo({ draggedDistance: F }), I && !o) {
        const Q = Sa(F), ce = Math.min(Q * -1, 0) * O;
        K(A.current, { transform: W(S) ? `translate3d(0, ${ce}px, 0)` : `translate3d(${ce}px, 0, 0)` });
        return;
      }
      const De = 1 - J;
      if ((Kt || m && he === m - 1) && (n?.(j, J), K(pe.current, {
        opacity: `${De}`,
        transition: "none"
      }, !0)), Y && pe.current && s) {
        const Q = Math.min(Ie() + J * (1 - Ie()), 1), ce = 8 - J * 8, Xt = Math.max(0, 14 - J * 14);
        K(Y, {
          borderRadius: `${ce}px`,
          transform: W(S) ? `scale(${Q}) translate3d(0, ${Xt}px, 0)` : `scale(${Q}) translate3d(${Xt}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!o) {
        const Q = X * O;
        K(A.current, { transform: W(S) ? `translate3d(0, ${Q}px, 0)` : `translate3d(${Q}px, 0, 0)` });
      }
    }
  }
  l.useEffect(() => {
    window.requestAnimationFrame(() => {
      Ut.current = !0;
    });
  }, []), l.useEffect(() => {
    var j;
    function O() {
      if (!A.current || !R) return;
      const F = document.activeElement;
      if (ut(F) || me.current) {
        var I;
        const V = ((I = window.visualViewport) == null ? void 0 : I.height) || 0, X = window.innerHeight;
        let Y = X - V;
        const J = A.current.getBoundingClientRect().height || 0, ge = J > X * 0.8;
        nt.current || (nt.current = J);
        const De = A.current.getBoundingClientRect().top;
        if (Math.abs(Vt.current - Y) > 60 && (me.current = !me.current), o && o.length > 0 && _e && he) {
          const Q = _e[he] || 0;
          Y += Q;
        }
        if (Vt.current = Y, J > V || me.current) {
          const Q = A.current.getBoundingClientRect().height;
          let ce = Q;
          Q > V && (ce = V - (ge ? De : dt)), y ? A.current.style.height = `${Q - Math.max(Y, 0)}px` : A.current.style.height = `${Math.max(ce, V - De)}px`;
        } else ca() || (A.current.style.height = `${nt.current}px`);
        o && o.length > 0 && !me.current ? A.current.style.bottom = "0px" : A.current.style.bottom = `${Math.max(Y, 0)}px`;
      }
    }
    return (j = window.visualViewport) == null || j.addEventListener("resize", O), () => {
      var F;
      return (F = window.visualViewport) == null ? void 0 : F.removeEventListener("resize", O);
    };
  }, [
    he,
    o,
    _e
  ]);
  function Re(j) {
    go(), g?.(), j || H(!1), setTimeout(() => {
      o && Wt(o[0]);
    }, U.DURATION * 1e3);
  }
  function Yt() {
    if (!A.current) return;
    const j = document.querySelector("[data-vaul-drawer-wrapper]"), O = $e(A.current, S);
    K(A.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${U.DURATION}s cubic-bezier(${U.EASE.join(",")})`
    }), K(pe.current, {
      transition: `opacity ${U.DURATION}s cubic-bezier(${U.EASE.join(",")})`,
      opacity: "1"
    }), s && O && O > 0 && L && K(j, {
      borderRadius: `${Dr}px`,
      overflow: "hidden",
      ...W(S) ? {
        transform: `scale(${Ie()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${Ie()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${U.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${U.EASE.join(",")})`
    }, !0);
  }
  function go() {
    !ne || !A.current || (A.current.classList.remove(st), Ce.current = !1, Qe(!1), et.current = /* @__PURE__ */ new Date());
  }
  function vo(j) {
    if (!ne || !A.current) return;
    A.current.classList.remove(st), Ce.current = !1, Qe(!1), et.current = /* @__PURE__ */ new Date();
    const O = $e(A.current, S);
    if (!j || !Gt(j.target, !1) || !O || Number.isNaN(O) || Ze.current === null) return;
    const F = et.current.getTime() - Ze.current.getTime(), I = rt.current - (W(S) ? j.pageY : j.pageX), V = Math.abs(I) / F;
    if (V > 0.05 && (zt(!0), setTimeout(() => {
      zt(!1);
    }, 200)), o) {
      co({
        draggedDistance: I * (S === "bottom" || S === "right" ? 1 : -1),
        closeDrawer: Re,
        velocity: V,
        dismissible: u
      }), a?.(j, !0);
      return;
    }
    if (S === "bottom" || S === "right" ? I > 0 : I < 0) {
      Yt(), a?.(j, !0);
      return;
    }
    if (V > Ir) {
      Re(), a?.(j, !1);
      return;
    }
    var X;
    const Y = Math.min((X = A.current.getBoundingClientRect().height) != null ? X : 0, window.innerHeight);
    var J;
    const ge = Math.min((J = A.current.getBoundingClientRect().width) != null ? J : 0, window.innerWidth);
    if (Math.abs(O) >= (S === "left" || S === "right" ? ge : Y) * d) {
      Re(), a?.(j, !1);
      return;
    }
    a?.(j, !0), Yt();
  }
  l.useEffect(() => (L && (K(document.documentElement, { scrollBehavior: "auto" }), Ae.current = /* @__PURE__ */ new Date()), () => {
    xa(document.documentElement, "scrollBehavior");
  }), [L]);
  function wo(j) {
    const O = j ? (window.innerWidth - ue) / window.innerWidth : 1, F = j ? -ue : 0;
    tt.current && window.clearTimeout(tt.current), K(A.current, {
      transition: `transform ${U.DURATION}s cubic-bezier(${U.EASE.join(",")})`,
      transform: W(S) ? `scale(${O}) translate3d(0, ${F}px, 0)` : `scale(${O}) translate3d(${F}px, 0, 0)`
    }), !j && A.current && (tt.current = setTimeout(() => {
      const I = $e(A.current, S);
      K(A.current, {
        transition: "none",
        transform: W(S) ? `translate3d(0, ${I}px, 0)` : `translate3d(${I}px, 0, 0)`
      });
    }, 500));
  }
  function bo(j, O) {
    if (O < 0) return;
    const F = (window.innerWidth - ue) / window.innerWidth, I = F + O * (1 - F), V = -ue + O * ue;
    K(A.current, {
      transform: W(S) ? `scale(${I}) translate3d(0, ${V}px, 0)` : `scale(${I}) translate3d(${V}px, 0, 0)`,
      transition: "none"
    });
  }
  function yo(j, O) {
    const F = W(S) ? window.innerHeight : window.innerWidth, I = O ? (F - ue) / F : 1, V = O ? -ue : 0;
    O && K(A.current, {
      transition: `transform ${U.DURATION}s cubic-bezier(${U.EASE.join(",")})`,
      transform: W(S) ? `scale(${I}) translate3d(0, ${V}px, 0)` : `scale(${I}) translate3d(${V}px, 0, 0)`
    });
  }
  return l.useEffect(() => {
    w || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [w]), /* @__PURE__ */ l.createElement(zo, {
    defaultOpen: D,
    onOpenChange: (j) => {
      !u && !j || (j ? re(!0) : Re(!0), H(j));
    },
    open: L
  }, /* @__PURE__ */ l.createElement(jr.Provider, { value: {
    activeSnapPoint: lo,
    snapPoints: o,
    setActiveSnapPoint: Wt,
    drawerRef: A,
    overlayRef: pe,
    onOpenChange: t,
    onPress: mo,
    onRelease: vo,
    onDrag: ho,
    dismissible: u,
    shouldAnimate: Ut,
    handleOnly: p,
    isOpen: L,
    isDragging: ne,
    shouldFade: Kt,
    closeDrawer: Re,
    onNestedDrag: bo,
    onNestedOpenChange: wo,
    onNestedRelease: yo,
    keyboardIsOpen: me,
    modal: w,
    snapPointsOffset: _e,
    activeSnapPointIndex: he,
    direction: S,
    shouldScaleBackground: s,
    setBackgroundColorOnScale: c,
    noBodyStyles: x,
    container: M,
    autoFocus: T
  } }, r));
}
var Lr = /* @__PURE__ */ l.forwardRef(function({ ...e }, t) {
  const { overlayRef: r, snapPoints: n, onRelease: a, shouldFade: o, isOpen: s, modal: c, shouldAnimate: d } = ye(), f = Tr(t, r), u = n && n.length > 0;
  if (!c) return null;
  const p = l.useCallback((m) => a(m), [a]);
  return /* @__PURE__ */ l.createElement(Ao, {
    onMouseUp: p,
    ref: f,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": s && u ? "true" : "false",
    "data-vaul-snap-points-overlay": s && o ? "true" : "false",
    "data-vaul-animate": d?.current ? "true" : "false",
    ...e
  });
});
Lr.displayName = "Drawer.Overlay";
var Fr = /* @__PURE__ */ l.forwardRef(function({ onPointerDownOutside: e, style: t, onOpenAutoFocus: r, ...n }, a) {
  const { drawerRef: o, onPress: s, onRelease: c, onDrag: d, keyboardIsOpen: f, snapPointsOffset: u, activeSnapPointIndex: p, modal: m, isOpen: h, direction: b, snapPoints: y, container: w, handleOnly: g, shouldAnimate: v, autoFocus: x } = ye(), [S, D] = l.useState(!1), N = Tr(a, o), _ = l.useRef(null), C = l.useRef(null), R = l.useRef(!1), P = y && y.length > 0;
  ka();
  const M = (E, $, L = 0) => {
    if (R.current) return !0;
    const H = Math.abs(E.y), G = Math.abs(E.x), re = G > H, ne = ["bottom", "right"].includes($) ? 1 : -1;
    if ($ === "left" || $ === "right") {
      if (!(E.x * ne < 0) && G >= 0 && G <= L) return re;
    } else if (!(E.y * ne < 0) && H >= 0 && H <= L) return !re;
    return R.current = !0, !0;
  };
  l.useEffect(() => {
    P && window.requestAnimationFrame(() => {
      D(!0);
    });
  }, []);
  function T(E) {
    _.current = null, R.current = !1, c(E);
  }
  return /* @__PURE__ */ l.createElement(Oo, {
    "data-vaul-drawer-direction": b,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": S ? "true" : "false",
    "data-vaul-snap-points": h && P ? "true" : "false",
    "data-vaul-custom-container": w ? "true" : "false",
    "data-vaul-animate": v?.current ? "true" : "false",
    ...n,
    ref: N,
    style: u && u.length > 0 ? {
      "--snap-point-height": `${u[p ?? 0]}px`,
      ...t
    } : t,
    onPointerDown: (E) => {
      g || (n.onPointerDown == null || n.onPointerDown.call(n, E), _.current = {
        x: E.pageX,
        y: E.pageY
      }, s(E));
    },
    onOpenAutoFocus: (E) => {
      r?.(E), x || E.preventDefault();
    },
    onPointerDownOutside: (E) => {
      if (e?.(E), !m || E.defaultPrevented) {
        E.preventDefault();
        return;
      }
      f.current && (f.current = !1);
    },
    onFocusOutside: (E) => {
      if (!m) {
        E.preventDefault();
        return;
      }
    },
    onPointerMove: (E) => {
      if (C.current = E, g || (n.onPointerMove == null || n.onPointerMove.call(n, E), !_.current)) return;
      const $ = E.pageY - _.current.y, L = E.pageX - _.current.x, H = E.pointerType === "touch" ? 10 : 2;
      M({
        x: L,
        y: $
      }, b, H) ? d(E) : (Math.abs(L) > H || Math.abs($) > H) && (_.current = null);
    },
    onPointerUp: (E) => {
      n.onPointerUp == null || n.onPointerUp.call(n, E), _.current = null, R.current = !1, c(E);
    },
    onPointerOut: (E) => {
      n.onPointerOut == null || n.onPointerOut.call(n, E), T(C.current);
    },
    onContextMenu: (E) => {
      n.onContextMenu == null || n.onContextMenu.call(n, E), C.current && T(C.current);
    }
  });
});
Fr.displayName = "Drawer.Content";
var Ta = 250, Aa = 120, Br = /* @__PURE__ */ l.forwardRef(function({ preventCycle: e = !1, children: t, ...r }, n) {
  const { closeDrawer: a, isDragging: o, snapPoints: s, activeSnapPoint: c, setActiveSnapPoint: d, dismissible: f, handleOnly: u, isOpen: p, onPress: m, onDrag: h } = ye(), b = l.useRef(null), y = l.useRef(!1);
  function w() {
    if (y.current) {
      x();
      return;
    }
    window.setTimeout(() => {
      g();
    }, Aa);
  }
  function g() {
    if (o || e || y.current) {
      x();
      return;
    }
    if (x(), !s || s.length === 0) {
      f || a();
      return;
    }
    if (c === s[s.length - 1] && f) {
      a();
      return;
    }
    const S = s.findIndex((N) => N === c);
    if (S === -1) return;
    const D = s[S + 1];
    d(D);
  }
  function v() {
    b.current = window.setTimeout(() => {
      y.current = !0;
    }, Ta);
  }
  function x() {
    b.current && window.clearTimeout(b.current), y.current = !1;
  }
  return /* @__PURE__ */ l.createElement("div", {
    onClick: w,
    onPointerCancel: x,
    onPointerDown: (S) => {
      u && m(S), v();
    },
    onPointerMove: (S) => {
      u && h(S);
    },
    ref: n,
    "data-vaul-drawer-visible": p ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...r
  }, /* @__PURE__ */ l.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, t));
});
Br.displayName = "Drawer.Handle";
function Ia({ onDrag: e, onOpenChange: t, open: r, ...n }) {
  const { onNestedDrag: a, onNestedOpenChange: o, onNestedRelease: s } = ye();
  if (!a) throw new Error("Drawer.NestedRoot must be placed in another drawer");
  return /* @__PURE__ */ l.createElement(Mr, {
    nested: !0,
    open: r,
    onClose: () => {
      o(!1);
    },
    onDrag: (c, d) => {
      a(c, d), e?.(c, d);
    },
    onOpenChange: (c) => {
      c && o(c), t?.(c);
    },
    onRelease: s,
    ...n
  });
}
function Da(e) {
  const t = ye(), { container: r = t.container, ...n } = e;
  return /* @__PURE__ */ l.createElement(ko, {
    container: r,
    ...n
  });
}
var le = {
  Root: Mr,
  NestedRoot: Ia,
  Content: Fr,
  Overlay: Lr,
  Trigger: No,
  Portal: Da,
  Handle: Br,
  Close: Mo,
  Title: Uo,
  Description: Io
};
function Oa({ ...e }) {
  return /* @__PURE__ */ (0, i.jsx)(le.Root, {
    "data-slot": "drawer",
    ...e
  });
}
function $a({ ...e }) {
  return /* @__PURE__ */ (0, i.jsx)(le.Trigger, {
    "data-slot": "drawer-trigger",
    ...e
  });
}
function Ma({ ...e }) {
  return /* @__PURE__ */ (0, i.jsx)(le.Portal, {
    "data-slot": "drawer-portal",
    ...e
  });
}
function zr({ ...e }) {
  return /* @__PURE__ */ (0, i.jsx)(le.Close, {
    "data-slot": "drawer-close",
    ...e
  });
}
function La({ className: e, ...t }) {
  return /* @__PURE__ */ (0, i.jsx)(le.Overlay, {
    "data-slot": "drawer-overlay",
    className: k("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50", e),
    ...t
  });
}
function Fa({ className: e, children: t, ...r }) {
  return /* @__PURE__ */ (0, i.jsxs)(Ma, {
    "data-slot": "drawer-portal",
    children: [/* @__PURE__ */ (0, i.jsx)(La, {}), /* @__PURE__ */ (0, i.jsxs)(le.Content, {
      "data-slot": "drawer-content",
      className: k("group/drawer-content bg-background fixed z-50 flex h-auto flex-col", "data-[vaul-drawer-direction=top]:inset-x-0 data-[vaul-drawer-direction=top]:top-0 data-[vaul-drawer-direction=top]:mb-24 data-[vaul-drawer-direction=top]:max-h-[80vh] data-[vaul-drawer-direction=top]:rounded-b-lg data-[vaul-drawer-direction=top]:border-b", "data-[vaul-drawer-direction=bottom]:inset-x-0 data-[vaul-drawer-direction=bottom]:bottom-0 data-[vaul-drawer-direction=bottom]:mt-24 data-[vaul-drawer-direction=bottom]:max-h-[80vh] data-[vaul-drawer-direction=bottom]:rounded-t-lg data-[vaul-drawer-direction=bottom]:border-t", "data-[vaul-drawer-direction=right]:inset-y-0 data-[vaul-drawer-direction=right]:right-0 data-[vaul-drawer-direction=right]:w-3/4 data-[vaul-drawer-direction=right]:border-l data-[vaul-drawer-direction=right]:sm:max-w-sm", "data-[vaul-drawer-direction=left]:inset-y-0 data-[vaul-drawer-direction=left]:left-0 data-[vaul-drawer-direction=left]:w-3/4 data-[vaul-drawer-direction=left]:border-r data-[vaul-drawer-direction=left]:sm:max-w-sm", e),
      ...r,
      children: [/* @__PURE__ */ (0, i.jsx)("div", { className: "bg-muted mx-auto mt-4 hidden h-2 w-[100px] shrink-0 rounded-full group-data-[vaul-drawer-direction=bottom]/drawer-content:block" }), t]
    })]
  });
}
function Ba({ className: e, ...t }) {
  return /* @__PURE__ */ (0, i.jsx)("div", {
    "data-slot": "drawer-header",
    className: k("flex flex-col gap-0.5 p-4 group-data-[vaul-drawer-direction=bottom]/drawer-content:text-center group-data-[vaul-drawer-direction=top]/drawer-content:text-center md:gap-1.5 md:text-left", e),
    ...t
  });
}
function za({ className: e, ...t }) {
  return /* @__PURE__ */ (0, i.jsx)(le.Title, {
    "data-slot": "drawer-title",
    className: k("text-foreground font-semibold", e),
    ...t
  });
}
function Ua({ className: e, ...t }) {
  return /* @__PURE__ */ (0, i.jsx)(le.Description, {
    "data-slot": "drawer-description",
    className: k("text-muted-foreground text-sm", e),
    ...t
  });
}
var Va = [["path", {
  d: "m9 18 6-6-6-6",
  key: "mthhwq"
}]], qa = de("chevron-right", Va), Ha = [["path", {
  d: "m7 15 5 5 5-5",
  key: "1hf1tw"
}], ["path", {
  d: "m7 9 5-5 5 5",
  key: "sgt6xg"
}]], Wa = de("chevrons-up-down", Ha), Ka = [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "1mglay"
}]], Ga = de("circle", Ka), Ya = [
  ["circle", {
    cx: "12",
    cy: "12",
    r: "1",
    key: "41hilf"
  }],
  ["circle", {
    cx: "19",
    cy: "12",
    r: "1",
    key: "1wjl8i"
  }],
  ["circle", {
    cx: "5",
    cy: "12",
    r: "1",
    key: "1pcz8c"
  }]
], Xa = de("ellipsis", Ya), Ja = [["path", {
  d: "M21 12a9 9 0 1 1-6.219-8.56",
  key: "13zald"
}]], Qa = de("loader-circle", Ja), Za = [
  ["path", {
    d: "M10 5H3",
    key: "1qgfaw"
  }],
  ["path", {
    d: "M12 19H3",
    key: "yhmn1j"
  }],
  ["path", {
    d: "M14 3v4",
    key: "1sua03"
  }],
  ["path", {
    d: "M16 17v4",
    key: "1q0r14"
  }],
  ["path", {
    d: "M21 12h-9",
    key: "1o4lsq"
  }],
  ["path", {
    d: "M21 19h-5",
    key: "1rlt1p"
  }],
  ["path", {
    d: "M21 5h-7",
    key: "1oszz2"
  }],
  ["path", {
    d: "M8 10v4",
    key: "tgpxqk"
  }],
  ["path", {
    d: "M8 12H3",
    key: "a7s4jb"
  }]
], es = de("sliders-horizontal", Za), ts = [
  ["path", {
    d: "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3",
    key: "1dgpiv"
  }],
  ["path", {
    d: "M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
    key: "xacw8m"
  }],
  ["path", {
    d: "M4 18v2",
    key: "jwo5n2"
  }],
  ["path", {
    d: "M20 18v2",
    key: "1ar1qi"
  }],
  ["path", {
    d: "M12 4v9",
    key: "oqhhn3"
  }]
], rs = de("sofa", ts), ns = ({ trigger: e, children: t, header: r, description: n, footer: a, ...o }) => /* @__PURE__ */ (0, i.jsxs)(Oa, {
  ...o,
  children: [/* @__PURE__ */ (0, i.jsx)($a, {
    asChild: !0,
    children: /* @__PURE__ */ (0, i.jsx)("button", {
      className: "flex items-center gap-2",
      children: e
    })
  }), /* @__PURE__ */ (0, i.jsxs)(Fa, { children: [
    /* @__PURE__ */ (0, i.jsxs)(Ba, { children: [/* @__PURE__ */ (0, i.jsxs)("div", {
      className: "flex items-center justify-between",
      children: [/* @__PURE__ */ (0, i.jsx)(za, {
        className: "text-xl font-medium",
        children: r
      }), /* @__PURE__ */ (0, i.jsx)(zr, { children: /* @__PURE__ */ (0, i.jsx)(Po, { className: "size-4" }) })]
    }), /* @__PURE__ */ (0, i.jsx)(Ua, { children: n })] }),
    /* @__PURE__ */ (0, i.jsx)("div", {
      className: "flex-1 overflow-y-auto min-h-0",
      "data-drawer-visible": "true",
      children: t
    }),
    a && /* @__PURE__ */ (0, i.jsx)("div", {
      className: "shrink-0 border-t bg-background",
      children: a
    })
  ] })]
}), Le = (e) => e.toLowerCase().replace(/[^a-z0-9-]/g, "-").replace(/-+/g, "-").replace(/^-+|-+$/g, ""), os = ["group_id"];
function as(e, t, r) {
  return e === "price" && t.includes("-") ? t.split("-").map((n) => Vo.format(Math.ceil(Number(n))).replace(".00", "")).join(" - ") : r || t;
}
function ss({ filterDetails: e = [], onChange: t }) {
  const r = e?.filter((o) => o.values?.length && !os.includes(o.name)) || [], n = (o, s) => {
    e?.find((c) => c.name === o) && t?.({ filterDetails: e?.map((c) => c.name !== o ? c : {
      ...c,
      values: c.values.filter((d) => d.value !== s)
    }) });
  }, a = () => {
    t?.({
      options: bt,
      filterDetails: null
    });
  };
  return r.length ? /* @__PURE__ */ (0, i.jsxs)("div", {
    className: "flex flex-wrap gap-2 items-center w-full md:pl-1 pr-4",
    children: [r.map((o) => o.values?.length ? o.values.map((s) => {
      const c = Ne.includes(s.value.toLowerCase()), d = as(o.name, s.value, s.display_name);
      return /* @__PURE__ */ (0, i.jsx)(Ro, {
        rounded: "pill",
        className: "capitalize",
        onRemove: () => n(o.name, s.value),
        children: c ? o.display_name : `${o.display_name}: ${d}`
      }, `${o.name}-${Le(s.value)}`);
    }) : []), /* @__PURE__ */ (0, i.jsx)(yr, {
      variant: "link",
      onClick: a,
      className: "hover:underline text-sm whitespace-nowrap",
      children: "Clear all"
    })]
  }) : null;
}
var We = "Checkbox", [is, Rl] = ie(We), [ls, Pt] = is(We);
function cs(e) {
  const { __scopeCheckbox: t, checked: r, children: n, defaultChecked: a, disabled: o, form: s, name: c, onCheckedChange: d, required: f, value: u = "on", internal_do_not_use_render: p } = e, [m, h] = be({
    prop: r,
    defaultProp: a ?? !1,
    onChange: d,
    caller: We
  }), [b, y] = l.useState(null), [w, g] = l.useState(null), v = l.useRef(!1), x = b ? !!s || !!b.closest("form") : !0, S = {
    checked: m,
    disabled: o,
    setChecked: h,
    control: b,
    setControl: y,
    name: c,
    form: s,
    value: u,
    hasConsumerStoppedPropagationRef: v,
    required: f,
    defaultChecked: se(a) ? !1 : a,
    isFormControl: x,
    bubbleInput: w,
    setBubbleInput: g
  };
  return /* @__PURE__ */ (0, i.jsx)(ls, {
    scope: t,
    ...S,
    children: us(p) ? p(S) : n
  });
}
var Ur = "CheckboxTrigger", Vr = l.forwardRef(({ __scopeCheckbox: e, onKeyDown: t, onClick: r, ...n }, a) => {
  const { control: o, value: s, disabled: c, checked: d, required: f, setControl: u, setChecked: p, hasConsumerStoppedPropagationRef: m, isFormControl: h, bubbleInput: b } = Pt(Ur, e), y = q(a, u), w = l.useRef(d);
  return l.useEffect(() => {
    const g = o?.form;
    if (g) {
      const v = () => p(w.current);
      return g.addEventListener("reset", v), () => g.removeEventListener("reset", v);
    }
  }, [o, p]), /* @__PURE__ */ (0, i.jsx)(z.button, {
    type: "button",
    role: "checkbox",
    "aria-checked": se(d) ? "mixed" : d,
    "aria-required": f,
    "data-state": Yr(d),
    "data-disabled": c ? "" : void 0,
    disabled: c,
    value: s,
    ...n,
    ref: y,
    onKeyDown: B(t, (g) => {
      g.key === "Enter" && g.preventDefault();
    }),
    onClick: B(r, (g) => {
      p((v) => se(v) ? !0 : !v), b && h && (m.current = g.isPropagationStopped(), m.current || g.stopPropagation());
    })
  });
});
Vr.displayName = Ur;
var qr = l.forwardRef((e, t) => {
  const { __scopeCheckbox: r, name: n, checked: a, defaultChecked: o, required: s, disabled: c, value: d, onCheckedChange: f, form: u, ...p } = e;
  return /* @__PURE__ */ (0, i.jsx)(cs, {
    __scopeCheckbox: r,
    checked: a,
    defaultChecked: o,
    disabled: c,
    required: s,
    onCheckedChange: f,
    name: n,
    form: u,
    value: d,
    internal_do_not_use_render: ({ isFormControl: m }) => /* @__PURE__ */ (0, i.jsxs)(i.Fragment, { children: [/* @__PURE__ */ (0, i.jsx)(Vr, {
      ...p,
      ref: t,
      __scopeCheckbox: r
    }), m && /* @__PURE__ */ (0, i.jsx)(Gr, { __scopeCheckbox: r })] })
  });
});
qr.displayName = We;
var Hr = "CheckboxIndicator", Wr = l.forwardRef((e, t) => {
  const { __scopeCheckbox: r, forceMount: n, ...a } = e, o = Pt(Hr, r);
  return /* @__PURE__ */ (0, i.jsx)(fe, {
    present: n || se(o.checked) || o.checked === !0,
    children: /* @__PURE__ */ (0, i.jsx)(z.span, {
      "data-state": Yr(o.checked),
      "data-disabled": o.disabled ? "" : void 0,
      ...a,
      ref: t,
      style: {
        pointerEvents: "none",
        ...e.style
      }
    })
  });
});
Wr.displayName = Hr;
var Kr = "CheckboxBubbleInput", Gr = l.forwardRef(({ __scopeCheckbox: e, ...t }, r) => {
  const { control: n, hasConsumerStoppedPropagationRef: a, checked: o, defaultChecked: s, required: c, disabled: d, name: f, value: u, form: p, bubbleInput: m, setBubbleInput: h } = Pt(Kr, e), b = q(r, h), y = qe(o), w = Ve(n);
  l.useEffect(() => {
    const v = m;
    if (!v) return;
    const x = window.HTMLInputElement.prototype, S = Object.getOwnPropertyDescriptor(x, "checked").set, D = !a.current;
    if (y !== o && S) {
      const N = new Event("click", { bubbles: D });
      v.indeterminate = se(o), S.call(v, se(o) ? !1 : o), v.dispatchEvent(N);
    }
  }, [
    m,
    y,
    o,
    a
  ]);
  const g = l.useRef(se(o) ? !1 : o);
  return /* @__PURE__ */ (0, i.jsx)(z.input, {
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: s ?? g.current,
    required: c,
    disabled: d,
    name: f,
    value: u,
    form: p,
    ...t,
    tabIndex: -1,
    ref: b,
    style: {
      ...t.style,
      ...w,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0,
      transform: "translateX(-100%)"
    }
  });
});
Gr.displayName = Kr;
function us(e) {
  return typeof e == "function";
}
function se(e) {
  return e === "indeterminate";
}
function Yr(e) {
  return se(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function ds({ className: e, ...t }) {
  return /* @__PURE__ */ (0, i.jsx)(qr, {
    "data-slot": "checkbox",
    className: k("peer border-input data-[state=checked]:bg-primary data-[state=checked]:text-white data-[state=checked]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50", e),
    ...t,
    children: /* @__PURE__ */ (0, i.jsx)(Wr, {
      "data-slot": "checkbox-indicator",
      className: "grid place-content-center text-current transition-none",
      children: /* @__PURE__ */ (0, i.jsx)(Ho, { className: "size-3.5 stroke-3" })
    })
  });
}
var El = /* @__PURE__ */ fr(Eo(), 1), fs = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
].reduce((e, t) => {
  const r = /* @__PURE__ */ wr(`Primitive.${t}`), n = l.forwardRef((a, o) => {
    const { asChild: s, ...c } = a, d = s ? r : t;
    return typeof window < "u" && (window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0), /* @__PURE__ */ (0, i.jsx)(d, {
      ...c,
      ref: o
    });
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {}), ps = "Label", Xr = l.forwardRef((e, t) => /* @__PURE__ */ (0, i.jsx)(fs.label, {
  ...e,
  ref: t,
  onMouseDown: (r) => {
    r.target.closest("button, input, select, textarea") || (e.onMouseDown?.(r), !r.defaultPrevented && r.detail > 1 && r.preventDefault());
  }
}));
Xr.displayName = ps;
var ms = Xr;
function Jr({ className: e, ...t }) {
  return /* @__PURE__ */ (0, i.jsx)(ms, {
    "data-slot": "label",
    className: k("gap-2 text-sm leading-none font-medium group-data-[disabled=true]:opacity-50 peer-disabled:opacity-50 flex items-center select-none group-data-[disabled=true]:pointer-events-none peer-disabled:cursor-not-allowed", e),
    ...t
  });
}
var it = "rovingFocusGroup.onEntryFocus", hs = {
  bubbles: !1,
  cancelable: !0
}, Te = "RovingFocusGroup", [ft, Qr, gs] = gr(Te), [vs, Zr] = ie(Te, [gs]), [ws, bs] = vs(Te), en = l.forwardRef((e, t) => /* @__PURE__ */ (0, i.jsx)(ft.Provider, {
  scope: e.__scopeRovingFocusGroup,
  children: /* @__PURE__ */ (0, i.jsx)(ft.Slot, {
    scope: e.__scopeRovingFocusGroup,
    children: /* @__PURE__ */ (0, i.jsx)(ys, {
      ...e,
      ref: t
    })
  })
}));
en.displayName = Te;
var ys = l.forwardRef((e, t) => {
  const { __scopeRovingFocusGroup: r, orientation: n, loop: a = !1, dir: o, currentTabStopId: s, defaultCurrentTabStopId: c, onCurrentTabStopIdChange: d, onEntryFocus: f, preventScrollOnEntryFocus: u = !1, ...p } = e, m = l.useRef(null), h = q(t, m), b = Ue(o), [y, w] = be({
    prop: s,
    defaultProp: c ?? null,
    onChange: d,
    caller: Te
  }), [g, v] = l.useState(!1), x = ae(f), S = Qr(r), D = l.useRef(!1), [N, _] = l.useState(0);
  return l.useEffect(() => {
    const C = m.current;
    if (C)
      return C.addEventListener(it, x), () => C.removeEventListener(it, x);
  }, [x]), /* @__PURE__ */ (0, i.jsx)(ws, {
    scope: r,
    orientation: n,
    dir: b,
    loop: a,
    currentTabStopId: y,
    onItemFocus: l.useCallback((C) => w(C), [w]),
    onItemShiftTab: l.useCallback(() => v(!0), []),
    onFocusableItemAdd: l.useCallback(() => _((C) => C + 1), []),
    onFocusableItemRemove: l.useCallback(() => _((C) => C - 1), []),
    children: /* @__PURE__ */ (0, i.jsx)(z.div, {
      tabIndex: g || N === 0 ? -1 : 0,
      "data-orientation": n,
      ...p,
      ref: h,
      style: {
        outline: "none",
        ...e.style
      },
      onMouseDown: B(e.onMouseDown, () => {
        D.current = !0;
      }),
      onFocus: B(e.onFocus, (C) => {
        const R = !D.current;
        if (C.target === C.currentTarget && R && !g) {
          const P = new CustomEvent(it, hs);
          if (C.currentTarget.dispatchEvent(P), !P.defaultPrevented) {
            const M = S().filter((T) => T.focusable);
            nn([
              M.find((T) => T.active),
              M.find((T) => T.id === y),
              ...M
            ].filter(Boolean).map((T) => T.ref.current), u);
          }
        }
        D.current = !1;
      }),
      onBlur: B(e.onBlur, () => v(!1))
    })
  });
}), tn = "RovingFocusGroupItem", rn = l.forwardRef((e, t) => {
  const { __scopeRovingFocusGroup: r, focusable: n = !0, active: a = !1, tabStopId: o, children: s, ...c } = e, d = pr(), f = o || d, u = bs(tn, r), p = u.currentTabStopId === f, m = Qr(r), { onFocusableItemAdd: h, onFocusableItemRemove: b, currentTabStopId: y } = u;
  return l.useEffect(() => {
    if (n)
      return h(), () => b();
  }, [
    n,
    h,
    b
  ]), /* @__PURE__ */ (0, i.jsx)(ft.ItemSlot, {
    scope: r,
    id: f,
    focusable: n,
    active: a,
    children: /* @__PURE__ */ (0, i.jsx)(z.span, {
      tabIndex: p ? 0 : -1,
      "data-orientation": u.orientation,
      ...c,
      ref: t,
      onMouseDown: B(e.onMouseDown, (w) => {
        n ? u.onItemFocus(f) : w.preventDefault();
      }),
      onFocus: B(e.onFocus, () => u.onItemFocus(f)),
      onKeyDown: B(e.onKeyDown, (w) => {
        if (w.key === "Tab" && w.shiftKey) {
          u.onItemShiftTab();
          return;
        }
        if (w.target !== w.currentTarget) return;
        const g = Cs(w, u.orientation, u.dir);
        if (g !== void 0) {
          if (w.metaKey || w.ctrlKey || w.altKey || w.shiftKey) return;
          w.preventDefault();
          let v = m().filter((x) => x.focusable).map((x) => x.ref.current);
          if (g === "last") v.reverse();
          else if (g === "prev" || g === "next") {
            g === "prev" && v.reverse();
            const x = v.indexOf(w.currentTarget);
            v = u.loop ? _s(v, x + 1) : v.slice(x + 1);
          }
          setTimeout(() => nn(v));
        }
      }),
      children: typeof s == "function" ? s({
        isCurrentTabStop: p,
        hasTabStop: y != null
      }) : s
    })
  });
});
rn.displayName = tn;
var xs = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Ss(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Cs(e, t, r) {
  const n = Ss(e.key, r);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(n)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(n)))
    return xs[n];
}
function nn(e, t = !1) {
  const r = document.activeElement;
  for (const n of e)
    if (n === r || (n.focus({ preventScroll: t }), document.activeElement !== r)) return;
}
function _s(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
var Rs = en, Es = rn, jt = "Radio", [Ps, on] = ie(jt), [js, ks] = Ps(jt), an = l.forwardRef((e, t) => {
  const { __scopeRadio: r, name: n, checked: a = !1, required: o, disabled: s, value: c = "on", onCheck: d, form: f, ...u } = e, [p, m] = l.useState(null), h = q(t, (w) => m(w)), b = l.useRef(!1), y = p ? f || !!p.closest("form") : !0;
  return /* @__PURE__ */ (0, i.jsxs)(js, {
    scope: r,
    checked: a,
    disabled: s,
    children: [/* @__PURE__ */ (0, i.jsx)(z.button, {
      type: "button",
      role: "radio",
      "aria-checked": a,
      "data-state": un(a),
      "data-disabled": s ? "" : void 0,
      disabled: s,
      value: c,
      ...u,
      ref: h,
      onClick: B(e.onClick, (w) => {
        a || d?.(), y && (b.current = w.isPropagationStopped(), b.current || w.stopPropagation());
      })
    }), y && /* @__PURE__ */ (0, i.jsx)(cn, {
      control: p,
      bubbles: !b.current,
      name: n,
      value: c,
      checked: a,
      required: o,
      disabled: s,
      form: f,
      style: { transform: "translateX(-100%)" }
    })]
  });
});
an.displayName = jt;
var sn = "RadioIndicator", ln = l.forwardRef((e, t) => {
  const { __scopeRadio: r, forceMount: n, ...a } = e, o = ks(sn, r);
  return /* @__PURE__ */ (0, i.jsx)(fe, {
    present: n || o.checked,
    children: /* @__PURE__ */ (0, i.jsx)(z.span, {
      "data-state": un(o.checked),
      "data-disabled": o.disabled ? "" : void 0,
      ...a,
      ref: t
    })
  });
});
ln.displayName = sn;
var Ns = "RadioBubbleInput", cn = l.forwardRef(({ __scopeRadio: e, control: t, checked: r, bubbles: n = !0, ...a }, o) => {
  const s = l.useRef(null), c = q(s, o), d = qe(r), f = Ve(t);
  return l.useEffect(() => {
    const u = s.current;
    if (!u) return;
    const p = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(p, "checked").set;
    if (d !== r && m) {
      const h = new Event("click", { bubbles: n });
      m.call(u, r), u.dispatchEvent(h);
    }
  }, [
    d,
    r,
    n
  ]), /* @__PURE__ */ (0, i.jsx)(z.input, {
    type: "radio",
    "aria-hidden": !0,
    defaultChecked: r,
    ...a,
    tabIndex: -1,
    ref: c,
    style: {
      ...a.style,
      ...f,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  });
});
cn.displayName = Ns;
function un(e) {
  return e ? "checked" : "unchecked";
}
var Ts = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
], Ke = "RadioGroup", [As, Pl] = ie(Ke, [Zr, on]), dn = Zr(), fn = on(), [Is, Ds] = As(Ke), pn = l.forwardRef((e, t) => {
  const { __scopeRadioGroup: r, name: n, defaultValue: a, value: o, required: s = !1, disabled: c = !1, orientation: d, dir: f, loop: u = !0, onValueChange: p, ...m } = e, h = dn(r), b = Ue(f), [y, w] = be({
    prop: o,
    defaultProp: a ?? null,
    onChange: p,
    caller: Ke
  });
  return /* @__PURE__ */ (0, i.jsx)(Is, {
    scope: r,
    name: n,
    required: s,
    disabled: c,
    value: y,
    onValueChange: w,
    children: /* @__PURE__ */ (0, i.jsx)(Rs, {
      asChild: !0,
      ...h,
      orientation: d,
      dir: b,
      loop: u,
      children: /* @__PURE__ */ (0, i.jsx)(z.div, {
        role: "radiogroup",
        "aria-required": s,
        "aria-orientation": d,
        "data-disabled": c ? "" : void 0,
        dir: b,
        ...m,
        ref: t
      })
    })
  });
});
pn.displayName = Ke;
var mn = "RadioGroupItem", hn = l.forwardRef((e, t) => {
  const { __scopeRadioGroup: r, disabled: n, ...a } = e, o = Ds(mn, r), s = o.disabled || n, c = dn(r), d = fn(r), f = l.useRef(null), u = q(t, f), p = o.value === a.value, m = l.useRef(!1);
  return l.useEffect(() => {
    const h = (y) => {
      Ts.includes(y.key) && (m.current = !0);
    }, b = () => m.current = !1;
    return document.addEventListener("keydown", h), document.addEventListener("keyup", b), () => {
      document.removeEventListener("keydown", h), document.removeEventListener("keyup", b);
    };
  }, []), /* @__PURE__ */ (0, i.jsx)(Es, {
    asChild: !0,
    ...c,
    focusable: !s,
    active: p,
    children: /* @__PURE__ */ (0, i.jsx)(an, {
      disabled: s,
      required: o.required,
      checked: p,
      ...d,
      ...a,
      name: o.name,
      ref: u,
      onCheck: () => o.onValueChange(a.value),
      onKeyDown: B((h) => {
        h.key === "Enter" && h.preventDefault();
      }),
      onFocus: B(a.onFocus, () => {
        m.current && f.current?.click();
      })
    })
  });
});
hn.displayName = mn;
var Os = "RadioGroupIndicator", gn = l.forwardRef((e, t) => {
  const { __scopeRadioGroup: r, ...n } = e;
  return /* @__PURE__ */ (0, i.jsx)(ln, {
    ...fn(r),
    ...n,
    ref: t
  });
});
gn.displayName = Os;
var $s = pn, Ms = hn, Ls = gn;
function kt({ className: e, ...t }) {
  return /* @__PURE__ */ (0, i.jsx)($s, {
    "data-slot": "radio-group",
    className: k("grid gap-3", e),
    ...t
  });
}
function Nt({ className: e, ...t }) {
  return /* @__PURE__ */ (0, i.jsx)(Ms, {
    "data-slot": "radio-group-item",
    className: k("border-input text-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 aspect-square size-4 shrink-0 rounded-full border shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50", e),
    ...t,
    children: /* @__PURE__ */ (0, i.jsx)(Ls, {
      "data-slot": "radio-group-indicator",
      className: "relative flex items-center justify-center",
      children: /* @__PURE__ */ (0, i.jsx)(Ga, { className: "fill-primary absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2" })
    })
  });
}
function Fs(e, t) {
  return l.useReducer((r, n) => t[r][n] ?? r, e);
}
var Tt = "ScrollArea", [vn, jl] = ie(Tt), [Bs, ee] = vn(Tt), wn = l.forwardRef((e, t) => {
  const { __scopeScrollArea: r, type: n = "hover", dir: a, scrollHideDelay: o = 600, ...s } = e, [c, d] = l.useState(null), [f, u] = l.useState(null), [p, m] = l.useState(null), [h, b] = l.useState(null), [y, w] = l.useState(null), [g, v] = l.useState(0), [x, S] = l.useState(0), [D, N] = l.useState(!1), [_, C] = l.useState(!1), R = q(t, (M) => d(M)), P = Ue(a);
  return /* @__PURE__ */ (0, i.jsx)(Bs, {
    scope: r,
    type: n,
    dir: P,
    scrollHideDelay: o,
    scrollArea: c,
    viewport: f,
    onViewportChange: u,
    content: p,
    onContentChange: m,
    scrollbarX: h,
    onScrollbarXChange: b,
    scrollbarXEnabled: D,
    onScrollbarXEnabledChange: N,
    scrollbarY: y,
    onScrollbarYChange: w,
    scrollbarYEnabled: _,
    onScrollbarYEnabledChange: C,
    onCornerWidthChange: v,
    onCornerHeightChange: S,
    children: /* @__PURE__ */ (0, i.jsx)(z.div, {
      dir: P,
      ...s,
      ref: R,
      style: {
        position: "relative",
        "--radix-scroll-area-corner-width": g + "px",
        "--radix-scroll-area-corner-height": x + "px",
        ...e.style
      }
    })
  });
});
wn.displayName = Tt;
var bn = "ScrollAreaViewport", yn = l.forwardRef((e, t) => {
  const { __scopeScrollArea: r, children: n, nonce: a, ...o } = e, s = ee(bn, r), c = q(t, l.useRef(null), s.onViewportChange);
  return /* @__PURE__ */ (0, i.jsxs)(i.Fragment, { children: [/* @__PURE__ */ (0, i.jsx)("style", {
    dangerouslySetInnerHTML: { __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}" },
    nonce: a
  }), /* @__PURE__ */ (0, i.jsx)(z.div, {
    "data-radix-scroll-area-viewport": "",
    ...o,
    ref: c,
    style: {
      overflowX: s.scrollbarXEnabled ? "scroll" : "hidden",
      overflowY: s.scrollbarYEnabled ? "scroll" : "hidden",
      ...e.style
    },
    children: /* @__PURE__ */ (0, i.jsx)("div", {
      ref: s.onContentChange,
      style: {
        minWidth: "100%",
        display: "table"
      },
      children: n
    })
  })] });
});
yn.displayName = bn;
var te = "ScrollAreaScrollbar", xn = l.forwardRef((e, t) => {
  const { forceMount: r, ...n } = e, a = ee(te, e.__scopeScrollArea), { onScrollbarXEnabledChange: o, onScrollbarYEnabledChange: s } = a, c = e.orientation === "horizontal";
  return l.useEffect(() => (c ? o(!0) : s(!0), () => {
    c ? o(!1) : s(!1);
  }), [
    c,
    o,
    s
  ]), a.type === "hover" ? /* @__PURE__ */ (0, i.jsx)(zs, {
    ...n,
    ref: t,
    forceMount: r
  }) : a.type === "scroll" ? /* @__PURE__ */ (0, i.jsx)(Us, {
    ...n,
    ref: t,
    forceMount: r
  }) : a.type === "auto" ? /* @__PURE__ */ (0, i.jsx)(Sn, {
    ...n,
    ref: t,
    forceMount: r
  }) : a.type === "always" ? /* @__PURE__ */ (0, i.jsx)(At, {
    ...n,
    ref: t
  }) : null;
});
xn.displayName = te;
var zs = l.forwardRef((e, t) => {
  const { forceMount: r, ...n } = e, a = ee(te, e.__scopeScrollArea), [o, s] = l.useState(!1);
  return l.useEffect(() => {
    const c = a.scrollArea;
    let d = 0;
    if (c) {
      const f = () => {
        window.clearTimeout(d), s(!0);
      }, u = () => {
        d = window.setTimeout(() => s(!1), a.scrollHideDelay);
      };
      return c.addEventListener("pointerenter", f), c.addEventListener("pointerleave", u), () => {
        window.clearTimeout(d), c.removeEventListener("pointerenter", f), c.removeEventListener("pointerleave", u);
      };
    }
  }, [a.scrollArea, a.scrollHideDelay]), /* @__PURE__ */ (0, i.jsx)(fe, {
    present: r || o,
    children: /* @__PURE__ */ (0, i.jsx)(Sn, {
      "data-state": o ? "visible" : "hidden",
      ...n,
      ref: t
    })
  });
}), Us = l.forwardRef((e, t) => {
  const { forceMount: r, ...n } = e, a = ee(te, e.__scopeScrollArea), o = e.orientation === "horizontal", s = Ye(() => d("SCROLL_END"), 100), [c, d] = Fs("hidden", {
    hidden: { SCROLL: "scrolling" },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return l.useEffect(() => {
    if (c === "idle") {
      const f = window.setTimeout(() => d("HIDE"), a.scrollHideDelay);
      return () => window.clearTimeout(f);
    }
  }, [
    c,
    a.scrollHideDelay,
    d
  ]), l.useEffect(() => {
    const f = a.viewport, u = o ? "scrollLeft" : "scrollTop";
    if (f) {
      let p = f[u];
      const m = () => {
        const h = f[u];
        p !== h && (d("SCROLL"), s()), p = h;
      };
      return f.addEventListener("scroll", m), () => f.removeEventListener("scroll", m);
    }
  }, [
    a.viewport,
    o,
    d,
    s
  ]), /* @__PURE__ */ (0, i.jsx)(fe, {
    present: r || c !== "hidden",
    children: /* @__PURE__ */ (0, i.jsx)(At, {
      "data-state": c === "hidden" ? "hidden" : "visible",
      ...n,
      ref: t,
      onPointerEnter: B(e.onPointerEnter, () => d("POINTER_ENTER")),
      onPointerLeave: B(e.onPointerLeave, () => d("POINTER_LEAVE"))
    })
  });
}), Sn = l.forwardRef((e, t) => {
  const r = ee(te, e.__scopeScrollArea), { forceMount: n, ...a } = e, [o, s] = l.useState(!1), c = e.orientation === "horizontal", d = Ye(() => {
    if (r.viewport) {
      const f = r.viewport.offsetWidth < r.viewport.scrollWidth, u = r.viewport.offsetHeight < r.viewport.scrollHeight;
      s(c ? f : u);
    }
  }, 10);
  return we(r.viewport, d), we(r.content, d), /* @__PURE__ */ (0, i.jsx)(fe, {
    present: n || o,
    children: /* @__PURE__ */ (0, i.jsx)(At, {
      "data-state": o ? "visible" : "hidden",
      ...a,
      ref: t
    })
  });
}), At = l.forwardRef((e, t) => {
  const { orientation: r = "vertical", ...n } = e, a = ee(te, e.__scopeScrollArea), o = l.useRef(null), s = l.useRef(0), [c, d] = l.useState({
    content: 0,
    viewport: 0,
    scrollbar: {
      size: 0,
      paddingStart: 0,
      paddingEnd: 0
    }
  }), f = Pn(c.viewport, c.content), u = {
    ...n,
    sizes: c,
    onSizesChange: d,
    hasThumb: f > 0 && f < 1,
    onThumbChange: (m) => o.current = m,
    onThumbPointerUp: () => s.current = 0,
    onThumbPointerDown: (m) => s.current = m
  };
  function p(m, h) {
    return Gs(m, s.current, c, h);
  }
  return r === "horizontal" ? /* @__PURE__ */ (0, i.jsx)(Vs, {
    ...u,
    ref: t,
    onThumbPositionChange: () => {
      if (a.viewport && o.current) {
        const m = a.viewport.scrollLeft, h = nr(m, c, a.dir);
        o.current.style.transform = `translate3d(${h}px, 0, 0)`;
      }
    },
    onWheelScroll: (m) => {
      a.viewport && (a.viewport.scrollLeft = m);
    },
    onDragScroll: (m) => {
      a.viewport && (a.viewport.scrollLeft = p(m, a.dir));
    }
  }) : r === "vertical" ? /* @__PURE__ */ (0, i.jsx)(qs, {
    ...u,
    ref: t,
    onThumbPositionChange: () => {
      if (a.viewport && o.current) {
        const m = a.viewport.scrollTop, h = nr(m, c);
        o.current.style.transform = `translate3d(0, ${h}px, 0)`;
      }
    },
    onWheelScroll: (m) => {
      a.viewport && (a.viewport.scrollTop = m);
    },
    onDragScroll: (m) => {
      a.viewport && (a.viewport.scrollTop = p(m));
    }
  }) : null;
}), Vs = l.forwardRef((e, t) => {
  const { sizes: r, onSizesChange: n, ...a } = e, o = ee(te, e.__scopeScrollArea), [s, c] = l.useState(), d = l.useRef(null), f = q(t, d, o.onScrollbarXChange);
  return l.useEffect(() => {
    d.current && c(getComputedStyle(d.current));
  }, [d]), /* @__PURE__ */ (0, i.jsx)(_n, {
    "data-orientation": "horizontal",
    ...a,
    ref: f,
    sizes: r,
    style: {
      bottom: 0,
      left: o.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
      right: o.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
      "--radix-scroll-area-thumb-width": Ge(r) + "px",
      ...e.style
    },
    onThumbPointerDown: (u) => e.onThumbPointerDown(u.x),
    onDragScroll: (u) => e.onDragScroll(u.x),
    onWheelScroll: (u, p) => {
      if (o.viewport) {
        const m = o.viewport.scrollLeft + u.deltaX;
        e.onWheelScroll(m), kn(m, p) && u.preventDefault();
      }
    },
    onResize: () => {
      d.current && o.viewport && s && n({
        content: o.viewport.scrollWidth,
        viewport: o.viewport.offsetWidth,
        scrollbar: {
          size: d.current.clientWidth,
          paddingStart: ze(s.paddingLeft),
          paddingEnd: ze(s.paddingRight)
        }
      });
    }
  });
}), qs = l.forwardRef((e, t) => {
  const { sizes: r, onSizesChange: n, ...a } = e, o = ee(te, e.__scopeScrollArea), [s, c] = l.useState(), d = l.useRef(null), f = q(t, d, o.onScrollbarYChange);
  return l.useEffect(() => {
    d.current && c(getComputedStyle(d.current));
  }, [d]), /* @__PURE__ */ (0, i.jsx)(_n, {
    "data-orientation": "vertical",
    ...a,
    ref: f,
    sizes: r,
    style: {
      top: 0,
      right: o.dir === "ltr" ? 0 : void 0,
      left: o.dir === "rtl" ? 0 : void 0,
      bottom: "var(--radix-scroll-area-corner-height)",
      "--radix-scroll-area-thumb-height": Ge(r) + "px",
      ...e.style
    },
    onThumbPointerDown: (u) => e.onThumbPointerDown(u.y),
    onDragScroll: (u) => e.onDragScroll(u.y),
    onWheelScroll: (u, p) => {
      if (o.viewport) {
        const m = o.viewport.scrollTop + u.deltaY;
        e.onWheelScroll(m), kn(m, p) && u.preventDefault();
      }
    },
    onResize: () => {
      d.current && o.viewport && s && n({
        content: o.viewport.scrollHeight,
        viewport: o.viewport.offsetHeight,
        scrollbar: {
          size: d.current.clientHeight,
          paddingStart: ze(s.paddingTop),
          paddingEnd: ze(s.paddingBottom)
        }
      });
    }
  });
}), [Hs, Cn] = vn(te), _n = l.forwardRef((e, t) => {
  const { __scopeScrollArea: r, sizes: n, hasThumb: a, onThumbChange: o, onThumbPointerUp: s, onThumbPointerDown: c, onThumbPositionChange: d, onDragScroll: f, onWheelScroll: u, onResize: p, ...m } = e, h = ee(te, r), [b, y] = l.useState(null), w = q(t, (R) => y(R)), g = l.useRef(null), v = l.useRef(""), x = h.viewport, S = n.content - n.viewport, D = ae(u), N = ae(d), _ = Ye(p, 10);
  function C(R) {
    g.current && f({
      x: R.clientX - g.current.left,
      y: R.clientY - g.current.top
    });
  }
  return l.useEffect(() => {
    const R = (P) => {
      const M = P.target;
      b?.contains(M) && D(P, S);
    };
    return document.addEventListener("wheel", R, { passive: !1 }), () => document.removeEventListener("wheel", R, { passive: !1 });
  }, [
    x,
    b,
    S,
    D
  ]), l.useEffect(N, [n, N]), we(b, _), we(h.content, _), /* @__PURE__ */ (0, i.jsx)(Hs, {
    scope: r,
    scrollbar: b,
    hasThumb: a,
    onThumbChange: ae(o),
    onThumbPointerUp: ae(s),
    onThumbPositionChange: N,
    onThumbPointerDown: ae(c),
    children: /* @__PURE__ */ (0, i.jsx)(z.div, {
      ...m,
      ref: w,
      style: {
        position: "absolute",
        ...m.style
      },
      onPointerDown: B(e.onPointerDown, (R) => {
        R.button === 0 && (R.target.setPointerCapture(R.pointerId), g.current = b.getBoundingClientRect(), v.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", h.viewport && (h.viewport.style.scrollBehavior = "auto"), C(R));
      }),
      onPointerMove: B(e.onPointerMove, C),
      onPointerUp: B(e.onPointerUp, (R) => {
        const P = R.target;
        P.hasPointerCapture(R.pointerId) && P.releasePointerCapture(R.pointerId), document.body.style.webkitUserSelect = v.current, h.viewport && (h.viewport.style.scrollBehavior = ""), g.current = null;
      })
    })
  });
}), Be = "ScrollAreaThumb", Rn = l.forwardRef((e, t) => {
  const { forceMount: r, ...n } = e, a = Cn(Be, e.__scopeScrollArea);
  return /* @__PURE__ */ (0, i.jsx)(fe, {
    present: r || a.hasThumb,
    children: /* @__PURE__ */ (0, i.jsx)(Ws, {
      ref: t,
      ...n
    })
  });
}), Ws = l.forwardRef((e, t) => {
  const { __scopeScrollArea: r, style: n, ...a } = e, o = ee(Be, r), s = Cn(Be, r), { onThumbPositionChange: c } = s, d = q(t, (p) => s.onThumbChange(p)), f = l.useRef(void 0), u = Ye(() => {
    f.current && (f.current(), f.current = void 0);
  }, 100);
  return l.useEffect(() => {
    const p = o.viewport;
    if (p) {
      const m = () => {
        u(), f.current || (f.current = Ys(p, c), c());
      };
      return c(), p.addEventListener("scroll", m), () => p.removeEventListener("scroll", m);
    }
  }, [
    o.viewport,
    u,
    c
  ]), /* @__PURE__ */ (0, i.jsx)(z.div, {
    "data-state": s.hasThumb ? "visible" : "hidden",
    ...a,
    ref: d,
    style: {
      width: "var(--radix-scroll-area-thumb-width)",
      height: "var(--radix-scroll-area-thumb-height)",
      ...n
    },
    onPointerDownCapture: B(e.onPointerDownCapture, (p) => {
      const m = p.target.getBoundingClientRect(), h = p.clientX - m.left, b = p.clientY - m.top;
      s.onThumbPointerDown({
        x: h,
        y: b
      });
    }),
    onPointerUp: B(e.onPointerUp, s.onThumbPointerUp)
  });
});
Rn.displayName = Be;
var It = "ScrollAreaCorner", En = l.forwardRef((e, t) => {
  const r = ee(It, e.__scopeScrollArea), n = !!(r.scrollbarX && r.scrollbarY);
  return r.type !== "scroll" && n ? /* @__PURE__ */ (0, i.jsx)(Ks, {
    ...e,
    ref: t
  }) : null;
});
En.displayName = It;
var Ks = l.forwardRef((e, t) => {
  const { __scopeScrollArea: r, ...n } = e, a = ee(It, r), [o, s] = l.useState(0), [c, d] = l.useState(0), f = !!(o && c);
  return we(a.scrollbarX, () => {
    const u = a.scrollbarX?.offsetHeight || 0;
    a.onCornerHeightChange(u), d(u);
  }), we(a.scrollbarY, () => {
    const u = a.scrollbarY?.offsetWidth || 0;
    a.onCornerWidthChange(u), s(u);
  }), f ? /* @__PURE__ */ (0, i.jsx)(z.div, {
    ...n,
    ref: t,
    style: {
      width: o,
      height: c,
      position: "absolute",
      right: a.dir === "ltr" ? 0 : void 0,
      left: a.dir === "rtl" ? 0 : void 0,
      bottom: 0,
      ...e.style
    }
  }) : null;
});
function ze(e) {
  return e ? parseInt(e, 10) : 0;
}
function Pn(e, t) {
  const r = e / t;
  return isNaN(r) ? 0 : r;
}
function Ge(e) {
  const t = Pn(e.viewport, e.content), r = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, n = (e.scrollbar.size - r) * t;
  return Math.max(n, 18);
}
function Gs(e, t, r, n = "ltr") {
  const a = Ge(r), o = a / 2, s = t || o, c = a - s, d = r.scrollbar.paddingStart + s, f = r.scrollbar.size - r.scrollbar.paddingEnd - c, u = r.content - r.viewport, p = n === "ltr" ? [0, u] : [u * -1, 0];
  return jn([d, f], p)(e);
}
function nr(e, t, r = "ltr") {
  const n = Ge(t), a = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, o = t.scrollbar.size - a, s = t.content - t.viewport, c = o - n, d = xt(e, r === "ltr" ? [0, s] : [s * -1, 0]);
  return jn([0, s], [0, c])(d);
}
function jn(e, t) {
  return (r) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const n = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + n * (r - e[0]);
  };
}
function kn(e, t) {
  return e > 0 && e < t;
}
var Ys = (e, t = () => {
}) => {
  let r = {
    left: e.scrollLeft,
    top: e.scrollTop
  }, n = 0;
  return (function a() {
    const o = {
      left: e.scrollLeft,
      top: e.scrollTop
    }, s = r.left !== o.left, c = r.top !== o.top;
    (s || c) && t(), r = o, n = window.requestAnimationFrame(a);
  })(), () => window.cancelAnimationFrame(n);
};
function Ye(e, t) {
  const r = ae(e), n = l.useRef(0);
  return l.useEffect(() => () => window.clearTimeout(n.current), []), l.useCallback(() => {
    window.clearTimeout(n.current), n.current = window.setTimeout(r, t);
  }, [r, t]);
}
function we(e, t) {
  const r = ae(t);
  hr(() => {
    let n = 0;
    if (e) {
      const a = new ResizeObserver(() => {
        cancelAnimationFrame(n), n = window.requestAnimationFrame(r);
      });
      return a.observe(e), () => {
        window.cancelAnimationFrame(n), a.unobserve(e);
      };
    }
  }, [e, r]);
}
var Xs = wn, Js = yn, Qs = En;
function Zs({ className: e, children: t, ...r }) {
  return /* @__PURE__ */ (0, i.jsxs)(Xs, {
    "data-slot": "scroll-area",
    className: k("relative", e),
    ...r,
    children: [
      /* @__PURE__ */ (0, i.jsx)(Js, {
        "data-slot": "scroll-area-viewport",
        className: "focus-visible:ring-ring/50 size-full rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:outline-1",
        children: t
      }),
      /* @__PURE__ */ (0, i.jsx)(ei, {}),
      /* @__PURE__ */ (0, i.jsx)(Qs, {})
    ]
  });
}
function ei({ className: e, orientation: t = "vertical", ...r }) {
  return /* @__PURE__ */ (0, i.jsx)(xn, {
    "data-slot": "scroll-area-scrollbar",
    orientation: t,
    className: k("flex touch-none p-px transition-colors select-none", t === "vertical" && "h-full w-2.5 border-l border-l-transparent", t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent", e),
    ...r,
    children: /* @__PURE__ */ (0, i.jsx)(Rn, {
      "data-slot": "scroll-area-thumb",
      className: "bg-border relative flex-1 rounded-full"
    })
  });
}
var Nn = ["PageUp", "PageDown"], Tn = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
], An = {
  "from-left": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowLeft"
  ],
  "from-right": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowRight"
  ],
  "from-bottom": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowLeft"
  ],
  "from-top": [
    "Home",
    "PageDown",
    "ArrowUp",
    "ArrowLeft"
  ]
}, xe = "Slider", [pt, ti, ri] = gr(xe), [In, kl] = ie(xe, [ri]), [ni, Xe] = In(xe), Dn = l.forwardRef((e, t) => {
  const { name: r, min: n = 0, max: a = 100, step: o = 1, orientation: s = "horizontal", disabled: c = !1, minStepsBetweenThumbs: d = 0, defaultValue: f = [n], value: u, onValueChange: p = () => {
  }, onValueCommit: m = () => {
  }, inverted: h = !1, form: b, ...y } = e, w = l.useRef(/* @__PURE__ */ new Set()), g = l.useRef(0), v = s === "horizontal" ? oi : ai, [x = [], S] = be({
    prop: u,
    defaultProp: f,
    onChange: (P) => {
      [...w.current][g.current]?.focus(), p(P);
    }
  }), D = l.useRef(x);
  function N(P) {
    R(P, ui(x, P));
  }
  function _(P) {
    R(P, g.current);
  }
  function C() {
    const P = D.current[g.current];
    x[g.current] !== P && m(x);
  }
  function R(P, M, { commit: T } = { commit: !1 }) {
    const E = mi(o), $ = xt(hi(Math.round((P - n) / o) * o + n, E), [n, a]);
    S((L = []) => {
      const H = li(L, $, M);
      if (pi(H, d * o)) {
        g.current = H.indexOf($);
        const G = String(H) !== String(L);
        return G && T && m(H), G ? H : L;
      } else return L;
    });
  }
  return /* @__PURE__ */ (0, i.jsx)(ni, {
    scope: e.__scopeSlider,
    name: r,
    disabled: c,
    min: n,
    max: a,
    valueIndexToChangeRef: g,
    thumbs: w.current,
    values: x,
    orientation: s,
    form: b,
    children: /* @__PURE__ */ (0, i.jsx)(pt.Provider, {
      scope: e.__scopeSlider,
      children: /* @__PURE__ */ (0, i.jsx)(pt.Slot, {
        scope: e.__scopeSlider,
        children: /* @__PURE__ */ (0, i.jsx)(v, {
          "aria-disabled": c,
          "data-disabled": c ? "" : void 0,
          ...y,
          ref: t,
          onPointerDown: B(y.onPointerDown, () => {
            c || (D.current = x);
          }),
          min: n,
          max: a,
          inverted: h,
          onSlideStart: c ? void 0 : N,
          onSlideMove: c ? void 0 : _,
          onSlideEnd: c ? void 0 : C,
          onHomeKeyDown: () => !c && R(n, 0, { commit: !0 }),
          onEndKeyDown: () => !c && R(a, x.length - 1, { commit: !0 }),
          onStepKeyDown: ({ event: P, direction: M }) => {
            if (!c) {
              const T = Nn.includes(P.key) || P.shiftKey && Tn.includes(P.key) ? 10 : 1, E = g.current, $ = x[E];
              R($ + o * T * M, E, { commit: !0 });
            }
          }
        })
      })
    })
  });
});
Dn.displayName = xe;
var [On, $n] = In(xe, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), oi = l.forwardRef((e, t) => {
  const { min: r, max: n, dir: a, inverted: o, onSlideStart: s, onSlideMove: c, onSlideEnd: d, onStepKeyDown: f, ...u } = e, [p, m] = l.useState(null), h = q(t, (x) => m(x)), b = l.useRef(void 0), y = Ue(a), w = y === "ltr", g = w && !o || !w && o;
  function v(x) {
    const S = b.current || p.getBoundingClientRect(), D = Dt([0, S.width], g ? [r, n] : [n, r]);
    return b.current = S, D(x - S.left);
  }
  return /* @__PURE__ */ (0, i.jsx)(On, {
    scope: e.__scopeSlider,
    startEdge: g ? "left" : "right",
    endEdge: g ? "right" : "left",
    direction: g ? 1 : -1,
    size: "width",
    children: /* @__PURE__ */ (0, i.jsx)(Mn, {
      dir: y,
      "data-orientation": "horizontal",
      ...u,
      ref: h,
      style: {
        ...u.style,
        "--radix-slider-thumb-transform": "translateX(-50%)"
      },
      onSlideStart: (x) => {
        const S = v(x.clientX);
        s?.(S);
      },
      onSlideMove: (x) => {
        const S = v(x.clientX);
        c?.(S);
      },
      onSlideEnd: () => {
        b.current = void 0, d?.();
      },
      onStepKeyDown: (x) => {
        const S = An[g ? "from-left" : "from-right"].includes(x.key);
        f?.({
          event: x,
          direction: S ? -1 : 1
        });
      }
    })
  });
}), ai = l.forwardRef((e, t) => {
  const { min: r, max: n, inverted: a, onSlideStart: o, onSlideMove: s, onSlideEnd: c, onStepKeyDown: d, ...f } = e, u = l.useRef(null), p = q(t, u), m = l.useRef(void 0), h = !a;
  function b(y) {
    const w = m.current || u.current.getBoundingClientRect(), g = Dt([0, w.height], h ? [n, r] : [r, n]);
    return m.current = w, g(y - w.top);
  }
  return /* @__PURE__ */ (0, i.jsx)(On, {
    scope: e.__scopeSlider,
    startEdge: h ? "bottom" : "top",
    endEdge: h ? "top" : "bottom",
    size: "height",
    direction: h ? 1 : -1,
    children: /* @__PURE__ */ (0, i.jsx)(Mn, {
      "data-orientation": "vertical",
      ...f,
      ref: p,
      style: {
        ...f.style,
        "--radix-slider-thumb-transform": "translateY(50%)"
      },
      onSlideStart: (y) => {
        const w = b(y.clientY);
        o?.(w);
      },
      onSlideMove: (y) => {
        const w = b(y.clientY);
        s?.(w);
      },
      onSlideEnd: () => {
        m.current = void 0, c?.();
      },
      onStepKeyDown: (y) => {
        const w = An[h ? "from-bottom" : "from-top"].includes(y.key);
        d?.({
          event: y,
          direction: w ? -1 : 1
        });
      }
    })
  });
}), Mn = l.forwardRef((e, t) => {
  const { __scopeSlider: r, onSlideStart: n, onSlideMove: a, onSlideEnd: o, onHomeKeyDown: s, onEndKeyDown: c, onStepKeyDown: d, ...f } = e, u = Xe(xe, r);
  return /* @__PURE__ */ (0, i.jsx)(z.span, {
    ...f,
    ref: t,
    onKeyDown: B(e.onKeyDown, (p) => {
      p.key === "Home" ? (s(p), p.preventDefault()) : p.key === "End" ? (c(p), p.preventDefault()) : Nn.concat(Tn).includes(p.key) && (d(p), p.preventDefault());
    }),
    onPointerDown: B(e.onPointerDown, (p) => {
      const m = p.target;
      m.setPointerCapture(p.pointerId), p.preventDefault(), u.thumbs.has(m) ? m.focus() : n(p);
    }),
    onPointerMove: B(e.onPointerMove, (p) => {
      p.target.hasPointerCapture(p.pointerId) && a(p);
    }),
    onPointerUp: B(e.onPointerUp, (p) => {
      const m = p.target;
      m.hasPointerCapture(p.pointerId) && (m.releasePointerCapture(p.pointerId), o(p));
    })
  });
}), Ln = "SliderTrack", Fn = l.forwardRef((e, t) => {
  const { __scopeSlider: r, ...n } = e, a = Xe(Ln, r);
  return /* @__PURE__ */ (0, i.jsx)(z.span, {
    "data-disabled": a.disabled ? "" : void 0,
    "data-orientation": a.orientation,
    ...n,
    ref: t
  });
});
Fn.displayName = Ln;
var mt = "SliderRange", Bn = l.forwardRef((e, t) => {
  const { __scopeSlider: r, ...n } = e, a = Xe(mt, r), o = $n(mt, r), s = q(t, l.useRef(null)), c = a.values.length, d = a.values.map((p) => Vn(p, a.min, a.max)), f = c > 1 ? Math.min(...d) : 0, u = 100 - Math.max(...d);
  return /* @__PURE__ */ (0, i.jsx)(z.span, {
    "data-orientation": a.orientation,
    "data-disabled": a.disabled ? "" : void 0,
    ...n,
    ref: s,
    style: {
      ...e.style,
      [o.startEdge]: f + "%",
      [o.endEdge]: u + "%"
    }
  });
});
Bn.displayName = mt;
var ht = "SliderThumb", zn = l.forwardRef((e, t) => {
  const r = ti(e.__scopeSlider), [n, a] = l.useState(null), o = q(t, (c) => a(c)), s = l.useMemo(() => n ? r().findIndex((c) => c.ref.current === n) : -1, [r, n]);
  return /* @__PURE__ */ (0, i.jsx)(si, {
    ...e,
    ref: o,
    index: s
  });
}), si = l.forwardRef((e, t) => {
  const { __scopeSlider: r, index: n, name: a, ...o } = e, s = Xe(ht, r), c = $n(ht, r), [d, f] = l.useState(null), u = q(t, (v) => f(v)), p = d ? s.form || !!d.closest("form") : !0, m = Ve(d), h = s.values[n], b = h === void 0 ? 0 : Vn(h, s.min, s.max), y = ci(n, s.values.length), w = m?.[c.size], g = w ? di(w, b, c.direction) : 0;
  return l.useEffect(() => {
    if (d)
      return s.thumbs.add(d), () => {
        s.thumbs.delete(d);
      };
  }, [d, s.thumbs]), /* @__PURE__ */ (0, i.jsxs)("span", {
    style: {
      transform: "var(--radix-slider-thumb-transform)",
      position: "absolute",
      [c.startEdge]: `calc(${b}% + ${g}px)`
    },
    children: [/* @__PURE__ */ (0, i.jsx)(pt.ItemSlot, {
      scope: e.__scopeSlider,
      children: /* @__PURE__ */ (0, i.jsx)(z.span, {
        role: "slider",
        "aria-label": e["aria-label"] || y,
        "aria-valuemin": s.min,
        "aria-valuenow": h,
        "aria-valuemax": s.max,
        "aria-orientation": s.orientation,
        "data-orientation": s.orientation,
        "data-disabled": s.disabled ? "" : void 0,
        tabIndex: s.disabled ? void 0 : 0,
        ...o,
        ref: u,
        style: h === void 0 ? { display: "none" } : e.style,
        onFocus: B(e.onFocus, () => {
          s.valueIndexToChangeRef.current = n;
        })
      })
    }), p && /* @__PURE__ */ (0, i.jsx)(Un, {
      name: a ?? (s.name ? s.name + (s.values.length > 1 ? "[]" : "") : void 0),
      form: s.form,
      value: h
    }, n)]
  });
});
zn.displayName = ht;
var ii = "RadioBubbleInput", Un = l.forwardRef(({ __scopeSlider: e, value: t, ...r }, n) => {
  const a = l.useRef(null), o = q(a, n), s = qe(t);
  return l.useEffect(() => {
    const c = a.current;
    if (!c) return;
    const d = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(d, "value").set;
    if (s !== t && f) {
      const u = new Event("input", { bubbles: !0 });
      f.call(c, t), c.dispatchEvent(u);
    }
  }, [s, t]), /* @__PURE__ */ (0, i.jsx)(z.input, {
    style: { display: "none" },
    ...r,
    ref: o,
    defaultValue: t
  });
});
Un.displayName = ii;
function li(e = [], t, r) {
  const n = [...e];
  return n[r] = t, n.sort((a, o) => a - o);
}
function Vn(e, t, r) {
  return xt(100 / (r - t) * (e - t), [0, 100]);
}
function ci(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function ui(e, t) {
  if (e.length === 1) return 0;
  const r = e.map((a) => Math.abs(a - t)), n = Math.min(...r);
  return r.indexOf(n);
}
function di(e, t, r) {
  const n = e / 2;
  return (n - Dt([0, 50], [0, n])(t) * r) * r;
}
function fi(e) {
  return e.slice(0, -1).map((t, r) => e[r + 1] - t);
}
function pi(e, t) {
  if (t > 0) {
    const r = fi(e);
    return Math.min(...r) >= t;
  }
  return !0;
}
function Dt(e, t) {
  return (r) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const n = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + n * (r - e[0]);
  };
}
function mi(e) {
  return (String(e).split(".")[1] || "").length;
}
function hi(e, t) {
  const r = Math.pow(10, t);
  return Math.round(e * r) / r;
}
var gi = Dn, vi = Fn, wi = Bn, bi = zn;
function yi({ className: e, defaultValue: t, value: r, min: n = 0, max: a = 100, ...o }) {
  const s = l.useMemo(() => Array.isArray(r) ? r : Array.isArray(t) ? t : [n, a], [
    r,
    t,
    n,
    a
  ]);
  return /* @__PURE__ */ (0, i.jsxs)(gi, {
    "data-slot": "slider",
    defaultValue: t,
    value: r,
    min: n,
    max: a,
    className: k("relative flex w-full touch-none items-center select-none data-[disabled]:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col", e),
    ...o,
    children: [/* @__PURE__ */ (0, i.jsx)(vi, {
      "data-slot": "slider-track",
      className: k("bg-muted relative grow overflow-hidden rounded-full data-[orientation=horizontal]:h-1.5 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1.5"),
      children: /* @__PURE__ */ (0, i.jsx)(wi, {
        "data-slot": "slider-range",
        className: k("bg-primary absolute data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full")
      })
    }), Array.from({ length: s.length }, (c, d) => /* @__PURE__ */ (0, i.jsx)(bi, {
      "data-slot": "slider-thumb",
      className: "border-primary ring-ring/50 block size-4 shrink-0 rounded-full border bg-white shadow-sm transition-[color,box-shadow] hover:ring-4 focus-visible:ring-4 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50"
    }, d))]
  });
}
var Je = "Switch", [xi, Nl] = ie(Je), [Si, Ci] = xi(Je), qn = l.forwardRef((e, t) => {
  const { __scopeSwitch: r, name: n, checked: a, defaultChecked: o, required: s, disabled: c, value: d = "on", onCheckedChange: f, form: u, ...p } = e, [m, h] = l.useState(null), b = q(t, (x) => h(x)), y = l.useRef(!1), w = m ? u || !!m.closest("form") : !0, [g, v] = be({
    prop: a,
    defaultProp: o ?? !1,
    onChange: f,
    caller: Je
  });
  return /* @__PURE__ */ (0, i.jsxs)(Si, {
    scope: r,
    checked: g,
    disabled: c,
    children: [/* @__PURE__ */ (0, i.jsx)(z.button, {
      type: "button",
      role: "switch",
      "aria-checked": g,
      "aria-required": s,
      "data-state": Gn(g),
      "data-disabled": c ? "" : void 0,
      disabled: c,
      value: d,
      ...p,
      ref: b,
      onClick: B(e.onClick, (x) => {
        v((S) => !S), w && (y.current = x.isPropagationStopped(), y.current || x.stopPropagation());
      })
    }), w && /* @__PURE__ */ (0, i.jsx)(Kn, {
      control: m,
      bubbles: !y.current,
      name: n,
      value: d,
      checked: g,
      required: s,
      disabled: c,
      form: u,
      style: { transform: "translateX(-100%)" }
    })]
  });
});
qn.displayName = Je;
var Hn = "SwitchThumb", Wn = l.forwardRef((e, t) => {
  const { __scopeSwitch: r, ...n } = e, a = Ci(Hn, r);
  return /* @__PURE__ */ (0, i.jsx)(z.span, {
    "data-state": Gn(a.checked),
    "data-disabled": a.disabled ? "" : void 0,
    ...n,
    ref: t
  });
});
Wn.displayName = Hn;
var _i = "SwitchBubbleInput", Kn = l.forwardRef(({ __scopeSwitch: e, control: t, checked: r, bubbles: n = !0, ...a }, o) => {
  const s = l.useRef(null), c = q(s, o), d = qe(r), f = Ve(t);
  return l.useEffect(() => {
    const u = s.current;
    if (!u) return;
    const p = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(p, "checked").set;
    if (d !== r && m) {
      const h = new Event("click", { bubbles: n });
      m.call(u, r), u.dispatchEvent(h);
    }
  }, [
    d,
    r,
    n
  ]), /* @__PURE__ */ (0, i.jsx)("input", {
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: r,
    ...a,
    tabIndex: -1,
    ref: c,
    style: {
      ...a.style,
      ...f,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  });
});
Kn.displayName = _i;
function Gn(e) {
  return e ? "checked" : "unchecked";
}
var Ri = qn, Ei = Wn;
function Pi({ className: e, ...t }) {
  return /* @__PURE__ */ (0, i.jsx)(Ri, {
    "data-slot": "switch",
    className: k("peer data-[state=checked]:bg-primary data-[state=unchecked]:bg-input focus-visible:border-ring focus-visible:ring-ring/50 dark:data-[state=unchecked]:bg-input/80 inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50", e),
    ...t,
    children: /* @__PURE__ */ (0, i.jsx)(Ei, {
      "data-slot": "switch-thumb",
      className: k("bg-background dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground pointer-events-none block size-4 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0")
    })
  });
}
var ji = 6, ki = (e) => {
  const t = e?.data?.swatch;
  if (!t || typeof t != "object") return null;
  const r = typeof t.color == "string" ? t.color : void 0, n = typeof t.url == "string" ? t.url : void 0, a = typeof t.border == "string" ? t.border : void 0;
  return !r && !n ? null : {
    color: r,
    url: n,
    border: a
  };
}, Ni = (e) => {
  if (e.type !== "multiple" && e.type !== "single") return !1;
  const t = e.options;
  return !!t && t.length === 1 && Ne.includes(t[0].value.toLowerCase());
};
function Ti({ facet: e, value: t = "", disabled: r = !1, css: n = {}, onChange: a }) {
  let o = Math.ceil(Number(e.min));
  const s = Math.floor(Number(e.max));
  Number(e.min) === Number(e.max) && (o = s);
  const c = t.split(/\s*(-|~)\s*/g), d = Number(c?.[0]) || o, f = Number(c?.[1]) || s, [u, p] = (0, l.useState)(d < o ? o : d), [m, h] = (0, l.useState)(f > s ? s : f), [b, y] = (0, l.useState)(u), [w, g] = (0, l.useState)(m), v = (0, l.useRef)({
    roundedMin: o,
    roundedMax: s
  }), x = e.name === "price", S = () => {
    b < Number(e.min) || b > m || w > Number(e.max) || w < b || b === Number(e.min) && w === Number(e.max) || a(`${b.toFixed(2).replace(".00", "")}-${w.toFixed(2).replace(".00", "")}`);
  }, D = (N, _) => {
    const C = Number(N.target.value);
    Number.isNaN(C) || (_ ? (p(C), C >= Number(e.min) && C <= w && y(C)) : (h(C), C >= b && C <= Number(e.max) && g(C)));
  };
  return (0, l.useEffect)(() => {
    const N = v.current;
    (N.roundedMin !== o || N.roundedMax !== s) && ((0, l.startTransition)(() => {
      p((_) => {
        const C = _ < o ? o : _;
        return C !== _ && y(C), C;
      }), h((_) => {
        const C = _ > s ? s : _;
        return C !== _ && g(C), C;
      });
    }), v.current = {
      roundedMin: o,
      roundedMax: s
    });
  }, [o, s]), /* @__PURE__ */ (0, i.jsxs)("div", {
    className: k("flex flex-col gap-4 px-4 pt-1 pb-4", n.root),
    children: [/* @__PURE__ */ (0, i.jsxs)("div", {
      className: k("flex gap-4 justify-between", n.container),
      children: [/* @__PURE__ */ (0, i.jsxs)("fieldset", {
        className: k("border relative px-3 py-1 flex items-center rounded-[4px] flex-1", u < Number(e.min) || u > Number(e.max) ? "border-red-500" : "", n.fieldset),
        children: [
          /* @__PURE__ */ (0, i.jsx)("legend", {
            className: "absolute -top-2 left-2 text-xs bg-white",
            children: "from"
          }),
          x && /* @__PURE__ */ (0, i.jsx)("span", { children: "$" }),
          /* @__PURE__ */ (0, i.jsx)("input", {
            type: "text",
            inputMode: "numeric",
            name: `${e.name}-min`,
            min: o,
            max: m,
            disabled: r,
            step: 1,
            "aria-label": `from ${e.display_name}`,
            value: u,
            onChange: (N) => D(N, !0),
            onKeyUp: (N) => {
              N.key === "Enter" && S();
            },
            onBlur: S,
            className: k("border-0 p-1 w-full", n.input)
          })
        ]
      }), /* @__PURE__ */ (0, i.jsxs)("fieldset", {
        className: k("border relative px-3 py-1 flex items-center rounded-[4px] flex-1 data-[error=true]:outline data-[error=true]:outline-red-500", m > Number(e.max) || m < Number(e.min) ? "border-red-500" : "", n.fieldset),
        children: [
          /* @__PURE__ */ (0, i.jsx)("legend", {
            className: "absolute -top-2 left-2 text-xs bg-white",
            children: "to"
          }),
          x && /* @__PURE__ */ (0, i.jsx)("span", { children: "$" }),
          /* @__PURE__ */ (0, i.jsx)("input", {
            type: "text",
            inputMode: "numeric",
            name: `${e.name}-max`,
            min: u,
            max: s,
            disabled: r,
            step: 1,
            "aria-label": `to ${e.display_name}`,
            "data-error": m > Number(e.max) || m < u,
            value: m,
            onChange: (N) => D(N, !1),
            onKeyUp: (N) => {
              N.key === "Enter" && S();
            },
            onBlur: S,
            className: k("border-0 p-1 w-full", n.input)
          })
        ]
      })]
    }), /* @__PURE__ */ (0, i.jsx)(yi, {
      value: [b, w],
      onValueChange: (N) => {
        p(N[0]), h(N[1]), y(N[0]), g(N[1]);
      },
      disabled: r,
      onValueCommit: S,
      min: o,
      max: s,
      step: 1,
      className: n.slider
    })]
  });
}
var Ai = ({ css: e = {}, facet: t, onChange: r, value: n, disabled: a = !1, getOptionHref: o }) => {
  const s = o ? "a" : "div";
  return /* @__PURE__ */ (0, i.jsx)("div", {
    className: k("flex flex-col px-4 pb-4", e.root),
    children: /* @__PURE__ */ (0, i.jsx)(kt, {
      name: t.name,
      value: n || "",
      className: k("gap-0", e.container),
      onValueChange: r,
      children: t.options.map((c) => {
        const d = n === c.value, f = o?.(t, c, d);
        return /* @__PURE__ */ (0, i.jsxs)(s, {
          ...f ? { href: f } : {},
          className: "flex items-center gap-1 my-1 text-sm leading-tight",
          children: [/* @__PURE__ */ (0, i.jsx)("span", {
            className: k("group/cb flex items-center justify-center size-7 p-[5px] rounded-full shrink-0", !a && "hover:bg-gray-100"),
            children: /* @__PURE__ */ (0, i.jsx)(Nt, {
              id: `${t.name}-${c.value}`,
              value: c.value,
              disabled: a,
              className: k("size-[18px] group-hover/cb:border-gray-400", e.checkbox)
            })
          }), /* @__PURE__ */ (0, i.jsx)(Jr, {
            htmlFor: `${t.name}-${c.value}`,
            className: k("text-sm", a ? "cursor-not-allowed" : "cursor-pointer"),
            children: c.display_name || c.value
          })]
        }, c.value);
      })
    })
  });
}, Yn = ({ css: e = {}, facet: t, onChange: r, value: n, disabled: a, showCount: o = !1, getOptionHref: s }) => {
  const c = n || [], d = (f) => {
    const u = c.includes(f.value), p = s?.(t, f, u), m = p ? "a" : "div", h = ki(f), b = (y) => {
      p && (y.metaKey || y.ctrlKey || y.shiftKey || y.altKey || y.button !== 0) || (y.preventDefault(), r(u ? c.filter((w) => w !== f.value) : [...c, f.value]));
    };
    return /* @__PURE__ */ (0, i.jsx)(m, {
      ...p ? {
        href: p,
        onClick: b
      } : { onClick: b },
      children: /* @__PURE__ */ (0, i.jsxs)("label", {
        "aria-label": `${f.display_name || f.value}`,
        className: k("flex items-center gap-1 text-sm leading-tight", h ? "group/cb my-0.5" : "my-1", a ? "cursor-not-allowed" : "cursor-pointer", e.container),
        children: [
          /* @__PURE__ */ (0, i.jsx)("span", {
            className: k("flex items-center justify-center rounded-full shrink-0 size-7 p-[5px]", !h && "group/cb", !a && !h && "hover:bg-gray-100"),
            children: /* @__PURE__ */ (0, i.jsx)(ds, {
              name: t.name,
              disabled: a,
              checked: u,
              className: k(h ? k("size-5 rounded-full border-0 shadow-none bg-cover bg-center", "data-[state=checked]:ring-[2px] data-[state=checked]:ring-offset-1 data-[state=checked]:ring-primary", "group-hover/cb:ring-1 group-hover/cb:ring-offset-1 group-hover/cb:ring-primary", "[&_svg]:hidden") : "size-[18px] group-hover/cb:border-gray-400 data-[state=checked]:group-hover/cb:border-primary", e.checkbox),
              style: h ? (() => {
                const y = !!h.color && /gradient\(/i.test(h.color), w = !!h.color && /conic-gradient\(/i.test(h.color);
                return {
                  backgroundColor: h.color && !y ? h.color : "transparent",
                  backgroundImage: h.url ? `url(${h.url})` : y ? h.color : void 0,
                  ...w ? { backgroundSize: "8px 8px" } : {},
                  ...h.border ? { border: `1px solid ${h.border}` } : {}
                };
              })() : void 0
            })
          }),
          /* @__PURE__ */ (0, i.jsx)("span", { children: f.display_name || f.value }),
          o && /* @__PURE__ */ (0, i.jsx)("span", {
            className: e.count,
            children: f.count
          })
        ]
      })
    }, f.value);
  };
  if (t.options.length === 1 && Ne.includes(t.options[0].value.toLowerCase())) {
    const f = t.options[0], u = c.includes(f.value), p = s?.(t, f, u), m = p ? "a" : "div", h = (b) => {
      p && (b.metaKey || b.ctrlKey || b.shiftKey || b.altKey || b.button !== 0) || (b.preventDefault(), r(u ? [] : [f.value]));
    };
    return /* @__PURE__ */ (0, i.jsxs)(m, {
      ...p ? {
        href: p,
        onClick: h
      } : { onClick: h },
      className: "flex items-center justify-between gap-2 px-4 py-3 cursor-pointer",
      children: [/* @__PURE__ */ (0, i.jsx)(Jr, {
        htmlFor: t.name,
        className: "text-base font-semibold cursor-pointer",
        children: t.display_name
      }), /* @__PURE__ */ (0, i.jsx)(Pi, {
        id: t.name,
        checked: u
      })]
    });
  }
  return t.options.length > ji ? /* @__PURE__ */ (0, i.jsx)(Zs, {
    type: "always",
    className: k("h-[225px]", "[&_[data-slot=scroll-area-thumb]]:bg-gray-400", "[&_[data-slot=scroll-area-scrollbar]]:w-2", "[&_[data-slot=scroll-area-scrollbar]]:right-4", e.root),
    children: /* @__PURE__ */ (0, i.jsx)("div", {
      className: "flex flex-col px-4",
      children: t.options.map(d)
    })
  }) : /* @__PURE__ */ (0, i.jsx)("div", {
    className: k("flex flex-col px-4 pb-4", e.root),
    children: t.options.map(d)
  });
};
function Ii(e) {
  return e.facet.type === "single" ? /* @__PURE__ */ (0, i.jsx)(Ai, { ...e }) : /* @__PURE__ */ (0, i.jsx)(Yn, { ...e });
}
function Di({ className: e, defaultOpen: t, getOptionHref: r, ...n }) {
  return (n.facet.type === "multiple" || n.facet.type === "single") && n.facet.options?.length === 1 && Ne.some((a) => a === n.facet.options[0].value.toLowerCase()) ? /* @__PURE__ */ (0, i.jsx)("div", {
    className: e,
    "data-facet-name": n.facet.name,
    children: /* @__PURE__ */ (0, i.jsx)(Yn, {
      ...n,
      value: Array.isArray(n.value) ? n.value : n.value ? [n.value] : [],
      onChange: n.onChange,
      getOptionHref: r
    })
  }) : /* @__PURE__ */ (0, i.jsxs)(Rr, {
    defaultOpen: t ?? ((Array.isArray(n.value) ? n.value.length > 0 : !!n.value) || n.facet.name === "current_category_int"),
    className: e,
    "data-facet-name": n.facet.name,
    children: [/* @__PURE__ */ (0, i.jsxs)(Er, {
      className: "w-full flex items-center justify-between font-semibold px-4 py-3 gap-2 text-left group/trigger",
      children: [n.facet.display_name, /* @__PURE__ */ (0, i.jsx)(yt, { className: "size-6 transition-transform will-change-transform group-data-[state=open]/trigger:rotate-180" })]
    }), /* @__PURE__ */ (0, i.jsx)(Pr, {
      forceMount: !0,
      children: n.facet.type === "range" ? /* @__PURE__ */ (0, i.jsx)(Ti, { ...n }) : /* @__PURE__ */ (0, i.jsx)(Ii, {
        ...n,
        getOptionHref: r
      })
    })]
  });
}
var Oi = ({ facets: e = [], selectedFilters: t = {}, onChange: r, getOptionHref: n, exclude: a = [], className: o, disabled: s, autoExpandCount: c }) => /* @__PURE__ */ (0, i.jsx)("section", {
  role: "region",
  "aria-label": "Filters",
  className: o,
  "data-testid": "filter-sidebar",
  children: (() => {
    const d = e.filter((u) => {
      if (u.hidden) return !1;
      const p = u.type === "range" ? u.min !== u.max : !0;
      return u.options?.every((m) => m.count <= 5) ? !1 : !a.includes(u.name) && p;
    });
    let f = 0;
    return d.map((u) => {
      const p = t[u.name], m = u.type === "range" ? typeof p == "string" ? p : void 0 : u.type === "single" ? typeof p == "string" ? p : Array.isArray(p) ? p[0] : void 0 : Array.isArray(p) ? p : p ? [p] : void 0, h = Ni(u), b = !h && c !== void 0 && f < c;
      return h || (f += 1), /* @__PURE__ */ (0, l.createElement)(Di, {
        key: u.name,
        facet: u,
        value: m,
        onChange: (y) => r?.(u.name, y),
        getOptionHref: n,
        disabled: s,
        ...b ? { defaultOpen: !0 } : {},
        key: u.name
      });
    });
  })()
}), $i = ({ children: e, className: t }) => /* @__PURE__ */ (0, i.jsxs)("div", {
  className: k("flex flex-col justify-center items-center py-12 gap-2", t),
  children: [
    /* @__PURE__ */ (0, i.jsx)("div", {
      className: "w-16 h-16 flex items-center justify-center rounded-full bg-gray-100",
      children: /* @__PURE__ */ (0, i.jsx)(rs, {})
    }),
    /* @__PURE__ */ (0, i.jsx)("p", {
      className: "text-2xl font-semibold text-primary ",
      children: "No products found"
    }),
    /* @__PURE__ */ (0, i.jsx)("p", {
      className: "text-muted max-w-md text-center",
      children: e
    })
  ]
}), Tl = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
});
function Mi(e, t, r = "https://placeholder.local", n) {
  const a = [t], o = new URLSearchParams(), s = [t];
  if (e.options) for (const [h, b] of Object.entries(e.options))
    b === bt[h] || !b || !(h in Jt) || o.set(Jt[h], b.toString());
  const c = t.includes("/search"), d = n?.whitelist?.length ? new Set(n.whitelist.map((h) => h.name)) : null, f = (h) => !d || d.has(h), u = e.filterDetails?.reduce((h, b) => f(b.name) ? h + (b.values?.length || 0) : h, 0) || 0;
  [...e.filterDetails ?? []].sort((h, b) => h.display_name.localeCompare(b.display_name)).forEach((h) => {
    if (!h.values?.length) return;
    const b = h.handle ?? Le(h.display_name), y = f(h.name);
    if (!c && h.type !== "range") if (Ne.includes(h.values[0].value.toLowerCase()) && h.values[0].value.toLowerCase() === "true") {
      a.push(b), y && u <= 2 && s.push(b);
      return;
    } else {
      const w = `${b}_${h.values?.map((g) => h.name === "current_category_int" && g.display_name ? Le(g.display_name) : Le(g.value)).sort().join("+")}`;
      a.push(w), y && u <= 2 && s.push(w);
      return;
    }
    h.values.forEach((w) => {
      o.append(`f_${h.name}`, w.value);
    });
  });
  const p = `/${a.join("--")}`, m = new URL(p, r);
  return o.forEach((h, b) => {
    m.searchParams.set(b, h);
  }), {
    url: m,
    canonicalUrl: new URL(s.join("--"), r)
  };
}
function or({ className: e, ...t }) {
  return /* @__PURE__ */ (0, i.jsx)("nav", {
    role: "navigation",
    "aria-label": "pagination",
    "data-slot": "pagination",
    className: k("mx-auto flex w-full justify-center", e),
    ...t
  });
}
function ar({ className: e, ...t }) {
  return /* @__PURE__ */ (0, i.jsx)("ul", {
    "data-slot": "pagination-content",
    className: k("flex flex-row items-center gap-1", e),
    ...t
  });
}
function Me({ ...e }) {
  return /* @__PURE__ */ (0, i.jsx)("li", {
    "data-slot": "pagination-item",
    ...e
  });
}
function gt({ className: e, isActive: t, isDisabled: r, size: n = "icon", onClick: a, ...o }) {
  return /* @__PURE__ */ (0, i.jsx)("a", {
    "aria-current": t ? "page" : void 0,
    "data-slot": "pagination-link",
    "data-active": t,
    className: k(br({
      variant: t ? "outline" : "ghost",
      size: n
    }), r && "pointer-events-none opacity-50", e),
    onClick: (s) => {
      if (r) {
        s.preventDefault();
        return;
      }
      a?.(s);
    },
    ...o
  });
}
function sr({ className: e, text: t = "Next", ...r }) {
  return /* @__PURE__ */ (0, i.jsxs)(gt, {
    "aria-label": "Go to next page",
    className: k("gap-1 px-2.5 sm:pr-2.5", e),
    ...r,
    children: [/* @__PURE__ */ (0, i.jsx)("span", {
      className: "hidden",
      children: t
    }), /* @__PURE__ */ (0, i.jsx)(qa, {})]
  });
}
function lt({ className: e, ...t }) {
  return /* @__PURE__ */ (0, i.jsxs)("span", {
    "aria-hidden": !0,
    "data-slot": "pagination-ellipsis",
    className: k("flex size-9 items-center justify-center", e),
    ...t,
    children: [/* @__PURE__ */ (0, i.jsx)(Xa, { className: "size-4" }), /* @__PURE__ */ (0, i.jsx)("span", {
      className: "sr-only",
      children: "More pages"
    })]
  });
}
var Li = ({ currentPage: e, totalNumResults: t, resultsPerPage: r, windowSize: n = 5, onChange: a }) => {
  const [o, s] = (0, l.useState)(0);
  return (0, l.useEffect)(() => {
    t && r && s(Math.ceil(t / r));
  }, [t, r]), {
    currentPage: e,
    goToPage: (u) => {
      e && u >= 1 && u <= o && a(u);
    },
    nextPage: () => {
      e && e < o && a(e + 1);
    },
    prevPage: () => {
      e && e > 1 && a(e - 1);
    },
    totalPages: o,
    pages: (0, l.useMemo)(() => {
      const u = [];
      if (e) {
        let p, m;
        if (o <= n)
          p = 1, m = o;
        else {
          const h = Math.floor(n / 2), b = Math.ceil(n / 2) - 1;
          e <= h ? (p = 1, m = n) : e + b >= o ? (p = o - n + 1, m = o) : (p = e - h, m = e + b);
        }
        p > 1 && (u.push(1), p > 2 && u.push(-1));
        for (let h = p; h <= m; h += 1) u.push(h);
        m < o && (m < o - 1 && u.push(-1), u.push(o));
      }
      return u;
    }, [
      e,
      o,
      n
    ])
  };
}, Fi = () => typeof window > "u" ? !1 : new URLSearchParams(window.location.search).get("enableOverfetch") === "true" ? !0 : window.sh_proxy?.enableOverfetch === !0, Bi = ({ routePathname: e }, t, r) => {
  const n = e || (typeof window < "u" ? window.location.pathname : "/"), a = {
    ...t.options || {},
    page: r
  }, { url: o } = Mi({
    ...t,
    options: a
  }, n);
  return `${o.pathname}?${o.searchParams.toString()}`;
}, ir = 5;
function zi({ windowSize: e = 5, currentPage: t = 1, disabled: r, className: n, mode: a = "link", config: o, state: s, generatePageHref: c, responsive: d = !1, ...f }) {
  const [u, p] = (0, l.useState)(e), m = (0, l.useRef)(null);
  (0, l.useEffect)(() => {
    if (!d) return;
    const v = () => {
      const x = Number(m.current?.parentElement?.clientWidth) || window.innerWidth;
      p(Math.max(1, Math.min(Math.floor(x / 60) - 4, e)));
    };
    return v(), window.addEventListener("resize", v), () => window.removeEventListener("resize", v);
  }, [e, d]);
  const h = a === "link" && Fi(), { pages: b, totalPages: y } = Li({
    ...f,
    windowSize: d ? u : e,
    currentPage: t
  });
  if (y <= 1) return null;
  const w = (v) => {
    if (c) return c(v);
    if (a === "link" && o && s) return Bi(o, s, v);
    const x = new URLSearchParams(typeof window < "u" ? window.location.search : "");
    return x.set("page", String(v)), `${typeof window < "u" ? window.location.pathname : ""}?${x.toString()}`;
  }, g = (v, x) => {
    a === "callback" && v.preventDefault(), f.onChange?.(x);
  };
  return h ? /* @__PURE__ */ (0, i.jsx)(or, {
    className: n,
    "data-testid": "pagination",
    children: /* @__PURE__ */ (0, i.jsxs)(ar, {
      className: "gap-0 items-stretch",
      children: [
        b.slice(0, ir).map((v) => /* @__PURE__ */ (0, i.jsx)(Me, { children: v === -1 ? /* @__PURE__ */ (0, i.jsx)(lt, { className: "border-y border-l" }) : /* @__PURE__ */ (0, i.jsx)(gt, {
          size: "icon",
          isActive: t === v,
          isDisabled: r,
          className: "border rounded-none data-[active=true]:bg-gray-500 data-[active=true]:text-white border-r-0 data-[active=true]:hover:bg-black",
          href: w(v),
          onClick: (x) => g(x, v),
          children: v
        }) }, v)),
        b.length > ir && /* @__PURE__ */ (0, i.jsx)(lt, { className: "border-y border-l" }),
        /* @__PURE__ */ (0, i.jsx)(Me, { children: /* @__PURE__ */ (0, i.jsx)(sr, {
          size: "default",
          text: "Next Page",
          isDisabled: t === y || r,
          "data-testid": "cio-pagination-next-button",
          className: "border rounded-l-none border-l-0 bg-black text-white hover:bg-gray-500 [&_span]:inline-block gap-0",
          href: w(t + 1),
          onClick: (v) => g(v, t + 1)
        }) })
      ]
    })
  }) : /* @__PURE__ */ (0, i.jsx)(or, {
    className: n,
    "data-testid": "pagination",
    ref: m,
    children: /* @__PURE__ */ (0, i.jsxs)(ar, {
      className: "gap-0",
      children: [b.map((v, x) => /* @__PURE__ */ (0, i.jsx)(Me, { children: v === -1 ? /* @__PURE__ */ (0, i.jsx)(lt, { className: "border-y border-l" }) : /* @__PURE__ */ (0, i.jsx)(gt, {
        size: "icon",
        isActive: t === v,
        isDisabled: r,
        className: k("border rounded-none data-[active=true]:bg-gray-500 data-[active=true]:text-white border-r-0 data-[active=true]:hover:bg-black", x === 0 ? "rounded-l-md" : ""),
        href: w(v),
        onClick: (S) => g(S, v),
        children: v
      }) }, x)), /* @__PURE__ */ (0, i.jsx)(Me, { children: /* @__PURE__ */ (0, i.jsx)(sr, {
        size: "default",
        text: "Next Page",
        isDisabled: t === y || r,
        "data-testid": "cio-pagination-next-button",
        className: "border rounded-l-none border-l-0 bg-black text-white hover:bg-gray-500 rounded-r-md [&_span]:inline-block gap-0",
        href: w(t + 1),
        onClick: (v) => g(v, t + 1)
      }) })]
    })
  });
}
var ve = (e) => `${e.sort_by}:${e.sort_order}`, Xn = (e, t) => {
  const [r, n] = t.split(":");
  return e.find((a) => a.sort_by === r && a.sort_order === n);
};
function Ui({ sortOptions: e = [], selectedSort: t, onChange: r, disabled: n }) {
  const a = (0, l.useCallback)((o) => {
    const s = Xn(e, o);
    s && r(s);
  }, [e, r]);
  return /* @__PURE__ */ (0, i.jsx)(kt, {
    value: ve(t),
    name: "sort_by",
    disabled: n,
    onValueChange: a,
    className: "flex flex-col gap-3",
    "data-testid": "sort-radios",
    children: e.map((o) => /* @__PURE__ */ (0, i.jsxs)("label", {
      className: "flex items-center gap-3 cursor-pointer text-sm",
      children: [/* @__PURE__ */ (0, i.jsx)(Nt, { value: ve(o) }), /* @__PURE__ */ (0, i.jsx)("span", { children: o.display_name })]
    }, ve(o)))
  });
}
function Vi({ isOpen: e = !1, sortOptions: t = [], selectedSort: r, onChange: n, disabled: a }) {
  const [o, s] = (0, l.useState)(e), c = (0, l.useRef)(null);
  To(c, () => s(!1));
  const d = (0, l.useMemo)(() => t.find((u) => u.sort_by === r.sort_by && u.sort_order === r.sort_order), [r, t]), f = (0, l.useCallback)((u) => {
    s(!1);
    const p = Xn(t, u);
    p && n(p);
  }, [t, n]);
  return /* @__PURE__ */ (0, i.jsxs)("div", {
    className: "relative inline-block",
    ref: c,
    children: [/* @__PURE__ */ (0, i.jsxs)("button", {
      type: "button",
      className: "flex items-center gap-2 px-3 py-2 border rounded-md text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed",
      disabled: a,
      onClick: () => s(!o),
      "data-testid": "sort-dropdown",
      "aria-expanded": o,
      children: [
        /* @__PURE__ */ (0, i.jsx)(Wa, { className: "size-4" }),
        /* @__PURE__ */ (0, i.jsx)("span", {
          className: "whitespace-nowrap font-medium",
          children: d?.display_name
        }),
        /* @__PURE__ */ (0, i.jsx)(yt, { className: k("size-4 transition-transform", o && "rotate-180") })
      ]
    }), /* @__PURE__ */ (0, i.jsx)("div", {
      className: k("absolute right-0 top-full mt-1 min-w-full flex-col gap-3 bg-white p-4 shadow-md border rounded-md z-20 whitespace-nowrap", o ? "flex" : "hidden"),
      children: /* @__PURE__ */ (0, i.jsx)(kt, {
        value: ve(r),
        name: "sort_by",
        disabled: a,
        onValueChange: f,
        className: "flex flex-col gap-3",
        children: t.map((u) => /* @__PURE__ */ (0, i.jsxs)("label", {
          className: "flex items-center gap-3 cursor-pointer text-sm",
          children: [/* @__PURE__ */ (0, i.jsx)(Nt, { value: ve(u) }), /* @__PURE__ */ (0, i.jsx)("span", { children: u.display_name })]
        }, ve(u)))
      })
    })]
  });
}
function Jn({ data: e, disabled: t, selectedFilters: r = {}, selectedSort: n, currentPage: a = 1, resultsPerPage: o, onFilterChange: s, onSortChange: c, onPageChange: d, onCardClick: f, onImpression: u, onClearFilters: p, getFilterOptionHref: m, getPageHref: h, config: b, excludeFacets: y = [], autoExpandCount: w, ...g }) {
  const v = (0, l.useRef)(null), x = qo("lg"), S = b?.show_filter_pills ?? !0, D = b?.show_result_count ?? !0;
  if (!e) return /* @__PURE__ */ (0, i.jsx)("div", { className: "min-h-[80vh]" });
  const N = e.facets || [], _ = e.results && e.results.length > 0, C = Yo(r, N), R = /* @__PURE__ */ (0, i.jsx)(Oi, {
    facets: N,
    selectedFilters: r,
    onChange: s,
    getOptionHref: m,
    exclude: y,
    disabled: t,
    autoExpandCount: w,
    className: "lg:border-r pb-8 lg:px-0 lg:pb-0 lg:pr-6 flex flex-col lg:w-52 shrink-0 [&>div+div]:border-t [&_[data-facet-name=current\\_category\\_int]]:capitalize"
  }), P = {
    sort_by: n?.sort_by || "relevance",
    sort_order: n?.sort_order || "descending"
  }, M = _ && D && /* @__PURE__ */ (0, i.jsxs)("span", {
    className: "whitespace-nowrap text-sm",
    children: [
      /* @__PURE__ */ (0, i.jsxs)("span", {
        className: "font-semibold",
        children: [new Intl.NumberFormat("en-US").format(e.total_num_results || 0), (e.total_num_results || 0) >= 1e4 ? "+" : ""]
      }),
      " ",
      "Results"
    ]
  });
  return /* @__PURE__ */ (0, i.jsxs)("section", {
    ...g,
    ref: v,
    className: "flex flex-col lg:flex-row px-2 md:px-5 pb-2 md:pb-5 gap-6",
    children: [x && R, /* @__PURE__ */ (0, i.jsxs)("div", {
      className: "w-full",
      children: [
        /* @__PURE__ */ (0, i.jsxs)("div", {
          className: "flex items-center justify-between gap-3 my-4",
          children: [
            M || /* @__PURE__ */ (0, i.jsx)("span", {}),
            _ && x && /* @__PURE__ */ (0, i.jsx)(Vi, {
              sortOptions: e.sort_options || [],
              selectedSort: P,
              disabled: t,
              onChange: (T) => c({
                sort_by: T.sort_by,
                sort_order: T.sort_order
              })
            }),
            !x && /* @__PURE__ */ (0, i.jsxs)(ns, {
              direction: "left",
              header: "Sort and Filter",
              trigger: /* @__PURE__ */ (0, i.jsxs)("span", {
                className: "flex items-center gap-2 px-3 py-2 border border-input-100 rounded-md text-sm hover:bg-black hover:text-white",
                children: [/* @__PURE__ */ (0, i.jsx)(es, { className: "size-4" }), /* @__PURE__ */ (0, i.jsx)("span", { children: "Sort & Filter" })]
              }),
              footer: /* @__PURE__ */ (0, i.jsx)("div", {
                className: "px-4 py-2",
                children: /* @__PURE__ */ (0, i.jsx)(zr, {
                  asChild: !0,
                  children: /* @__PURE__ */ (0, i.jsx)(yr, {
                    type: "button",
                    className: "w-full",
                    children: "Show Results"
                  })
                })
              }),
              children: [_ && (e.sort_options?.length ?? 0) > 0 && /* @__PURE__ */ (0, i.jsxs)(Rr, {
                defaultOpen: !0,
                className: "border-y",
                children: [/* @__PURE__ */ (0, i.jsxs)(Er, {
                  className: "w-full flex items-center justify-between font-semibold px-4 py-3 gap-2 text-left group/trigger",
                  children: ["Sort", /* @__PURE__ */ (0, i.jsx)(yt, { className: "size-6 transition-transform will-change-transform group-data-[state=open]/trigger:rotate-180" })]
                }), /* @__PURE__ */ (0, i.jsx)(Pr, { children: /* @__PURE__ */ (0, i.jsx)("div", {
                  className: "px-4 pb-4",
                  children: /* @__PURE__ */ (0, i.jsx)(Ui, {
                    sortOptions: e.sort_options || [],
                    selectedSort: P,
                    disabled: t,
                    onChange: (T) => c({
                      sort_by: T.sort_by,
                      sort_order: T.sort_order
                    })
                  })
                }) })]
              }), R]
            })
          ]
        }),
        S && /* @__PURE__ */ (0, i.jsx)(ss, {
          facets: N,
          filterDetails: C,
          onChange: (T) => {
            if (T.filterDetails === null) if (p) p();
            else for (const E of Object.keys(r)) s(E, []);
            else if (T.filterDetails) {
              const E = Go(T.filterDetails);
              for (const $ of Object.keys(r)) if (!($ in E)) {
                s($, []);
                return;
              }
              for (const [$, L] of Object.entries(E)) {
                if (L == null) continue;
                const H = r[$];
                if (JSON.stringify(H) !== JSON.stringify(L)) {
                  s($, L);
                  return;
                }
              }
            }
          }
        }),
        !_ && /* @__PURE__ */ (0, i.jsx)($i, { children: "Looks like those filters are a little too specific! Try removing one or two to see more beautiful pieces." }),
        e.results && e.results.length > 0 && /* @__PURE__ */ (0, i.jsxs)("div", {
          "data-testid": "collection-grid",
          children: [/* @__PURE__ */ (0, i.jsx)("div", {
            className: "grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-x-2 gap-y-4 md:gap-6",
            children: e.results?.map((T, E) => /* @__PURE__ */ (0, i.jsx)(Wo, {
              lazyLoadImage: E > 7,
              highPriority: E === 0,
              data: T,
              css: {
                imageWrapper: "aspect-square [&_a]:leading-snug",
                price: "text-xl md:text-2xl !leading-none"
              },
              itemIndex: E,
              onImpression: u,
              config: b,
              onClick: ($, L) => f?.($, L, E),
              badgeData: N?.filter(($) => $?.data?.badge)
            }, T.id ?? E))
          }), /* @__PURE__ */ (0, i.jsx)(zi, {
            disabled: t,
            className: "mt-6",
            mode: h ? "link" : "callback",
            currentPage: a,
            totalNumResults: e.total_num_results || 0,
            resultsPerPage: o,
            generatePageHref: h,
            onChange: (T) => {
              d(T), v.current && v.current.scrollIntoView({ behavior: "smooth" });
            }
          })]
        })
      ]
    })]
  });
}
var qi = async (e, t) => {
  if (!window.__STOREFRONT_ACCESS_TOKEN__) throw new Error("Storefront access token is not set");
  const r = await fetch(`${window.Shopify.routes.root === "/" ? "" : window.Shopify.routes.root}/api/2025-07/graphql.json`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": window.__STOREFRONT_ACCESS_TOKEN__
    },
    body: JSON.stringify({
      query: e,
      variables: t
    })
  });
  if (!r.ok) throw new Error(`Response status: ${r.status}`);
  return await r.json();
}, lr = /* @__PURE__ */ new Map(), Hi = Promise.resolve([]), Wi = async (e) => {
  if (typeof window > "u" || !window?.__STOREFRONT_ACCESS_TOKEN__ || !e.length)
    return console.warn("Shopify Storefront API Access Token is not set"), Hi;
  const t = [...e].sort().join(","), r = lr.get(t);
  if (r) return r;
  const n = qi(`query GetProductData($ids: [ID!]!) {
      nodes(ids: $ids) {
        id
        ... on Product {
          title,
          id,
          onlineStoreUrl,
          images(first: 2) {
            nodes {
              url
            }
          }
          tags
          manufacturer: metafield(namespace: "custom", key: "manufacturer") { value }
          on_sale: metafield(namespace: "custom", key: "on_sale") { value }
          rating: metafield(namespace: "reviews", key: "rating") { value }
          rating_count: metafield(namespace: "reviews", key: "rating_count") { value }
          variants(first: 1) {
            nodes {
              availableForSale
              price {
                amount
              }
              compareAtPrice {
                amount
              }
            }
          }
        }
      }
    }`, { ids: e.map((a) => a.includes("gid://") ? a : `gid://shopify/Product/${a}`) }).then(({ data: a }) => a?.nodes.filter(Boolean)).catch((a) => (console.error("[fetchShopifyProducts]", a), []));
  return lr.set(t, n), n;
}, Ot = (e, t = !0) => {
  const r = !t || e.length === 0 || typeof window > "u" || !window?.__STOREFRONT_ACCESS_TOKEN__, n = r ? "" : [...e].sort().join(","), a = (0, l.useRef)(e);
  a.current = e;
  const [o, s] = (0, l.useState)(() => ({
    key: n,
    data: r ? [] : void 0
  }));
  return (0, l.useEffect)(() => {
    if (r) {
      s((d) => d.key === "" && d.data?.length === 0 ? d : {
        key: "",
        data: []
      });
      return;
    }
    let c = !1;
    return s((d) => d.key === n ? d : {
      key: n,
      data: void 0
    }), Wi(a.current).then((d) => {
      c || s((f) => f.key === n && f.data !== void 0 ? f : {
        key: n,
        data: d ?? []
      });
    }), () => {
      c = !0;
    };
  }, [r, n]), o.key === n ? o.data : void 0;
}, cr = !1;
function $t(e) {
  const t = (0, l.useMemo)(() => Do(e), [e]), r = (0, l.useCallback)((o, s, c) => {
    const { name: d, id: f, variation_id: u } = o;
    t?.tracker.trackRecommendationClick({
      variationId: u,
      resultId: c.result_id,
      resultCount: c.response?.total_num_results || 0,
      resultPositionOnPage: s + 1,
      podId: c.pod_id,
      strategyId: "complimentary",
      itemId: f,
      itemName: d
    });
  }, [t]), n = (0, l.useCallback)((o, s, c) => {
    const { name: d, id: f, variation_id: u } = o;
    t?.tracker.trackSearchResultClick(c.query, {
      itemId: f,
      itemName: d,
      variationId: u,
      section: s.options?.section,
      resultId: c.result_id
    });
  }, [t]), a = (0, l.useCallback)((o, s, c, d) => {
    if (!d.filterName && !d.filterValue) return;
    const { id: f, variation_id: u } = o;
    t?.tracker.trackBrowseResultClick({
      variationId: u,
      resultId: d.result_id,
      resultCount: d.response?.total_num_results || 0,
      resultPage: c.options?.page,
      resultPositionOnPage: s + 1,
      numResultsPerPage: c.options?.resultsPerPage,
      selectedFilters: c.filterDetails?.reduce((p, m) => (m.values?.length && (m.values.length === 1 ? p[m.name] = m.values[0].value : p[m.name] = m.values.map((h) => h.value)), p), {}),
      filterName: d.filterName,
      filterValue: d.filterValue,
      itemId: f
    }), window.igEvents && window.igEvents.push({
      event: "product_card_click",
      resultId: d.result_id,
      product: {
        id: f,
        name: o.name,
        url: o.url,
        variantId: u,
        is_sponsored: o.is_sponsored
      },
      position: s + 1,
      resultCount: d.response?.total_num_results || 0
    });
  }, [t]);
  return (0, l.useEffect)(() => {
    t && cr !== !0 && (cr = t.tracker.trackSessionStart());
  }, [t]), {
    handleRecommendationsClick: r,
    handleSearchClick: n,
    handleBrowseClick: a
  };
}
var Ki = "https://api.topsort.com", Qn = {
  auctions: "v2/auctions",
  events: "v2/events"
}, ur = "0.4.1", Gi = class {
  constructor(e, t, r, n = !1) {
    Z(this, "status", void 0), Z(this, "statusText", void 0), Z(this, "body", void 0), Z(this, "retry", void 0), this.status = e, this.statusText = t, this.body = r, this.retry = n;
  }
}, je = Gi, Yi = class {
  async handleResponse(e) {
    let t;
    if (e.status !== 204 && (t = await e.json()), !e.ok) {
      let r = e.status === 429 || e.status >= 500;
      throw new je(e.status, e.statusText, t, r);
    }
    return t;
  }
  async request(e, t) {
    try {
      let r = this.sanitizeUrl(e), n = await fetch(r, t);
      return this.handleResponse(n);
    } catch (r) {
      throw new je(500, "Internal Server Error", r instanceof Error ? r.message : "Unknown error");
    }
  }
  setupTimeoutSignal(e) {
    if (e.timeout != null) {
      let t = new AbortController();
      return setTimeout(() => t.abort(), e.timeout), t.signal;
    }
  }
  async post(e, t, r) {
    let n = this.setupTimeoutSignal(r), a = r.fetchOptions ?? { keepalive: !0 };
    return this.request(e, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-UA": r.userAgent ? `@topsort/sdk ${ur} ${r.userAgent}` : `@topsort/sdk ${ur}`,
        Authorization: `Bearer ${r.apiKey}`
      },
      body: JSON.stringify(t),
      signal: n,
      ...a
    });
  }
  sanitizeUrl(e) {
    try {
      return new URL(e).href.replace(/\/+$/, "");
    } catch (t) {
      throw new je(400, "Invalid URL", { error: `Invalid URL: ${t}` });
    }
  }
}, Zn = new Yi();
function Xi(e) {
  if (!e?.apiKey?.length) throw new je(401, "API Key is required.", {});
}
function eo(e) {
  return async (...t) => {
    let r = t[t.length - 1];
    return Xi(r), e(...t);
  };
}
async function Ji(e, t) {
  let r = `${t.host}/${Qn.auctions}`;
  return await Zn.post(r.toString(), e, t);
}
var Qi = eo(Ji);
async function Zi(e, t) {
  try {
    let r = `${t.host}/${Qn.events}`;
    return await Zn.post(r, e, t), {
      ok: !0,
      retry: !1
    };
  } catch (r) {
    if (r instanceof je && r.retry) return {
      ok: !1,
      retry: !0
    };
    throw r;
  }
}
var el = eo(Zi), tl = class {
  constructor(e) {
    Z(this, "config", void 0), this.config = e, this.config.host = this.config.host ?? Ki;
  }
  async reportEvent(e) {
    return el(e, this.config);
  }
  async createAuction(e) {
    return Qi(e, this.config);
  }
}, to = tl;
function Mt(e) {
  const t = (0, l.useMemo)(() => typeof window > "u" || !e?.apiKey ? null : new to({ apiKey: e.apiKey }), [e?.apiKey]);
  return { reportEvent: (0, l.useCallback)(async (r) => {
    if (!t) {
      console.error("Topsort client not initialized");
      return;
    }
    await t.reportEvent(r);
  }, [t]) };
}
var rl = (e, t = []) => e.map((r) => {
  const n = t.find((f) => f?.id.includes(r.id) && f.variants.nodes[0].availableForSale);
  if (!n) return null;
  const a = JSON.parse(n.rating?.value || "{}"), o = Number(n.variants.nodes[0].compareAtPrice?.amount || 0) || 0, s = Number(n.variants.nodes[0].price.amount) || 0;
  let c = n.on_sale?.value === "true";
  !c && o > 0 && s < o * 0.95 && (c = !0);
  const d = n.tags || [];
  return {
    id: n.id,
    name: n.title,
    url: n.onlineStoreUrl,
    images: n.images?.nodes.map((f) => f.url) || [],
    price: s,
    compareAtPrice: o,
    rating: Number(a?.value || 0),
    rating_count: Number(n.rating_count?.value || 0),
    manufacturer: n.manufacturer?.value || "",
    on_sale: c,
    is_sponsored: !0,
    new_arrivals: d.includes("new-arrival"),
    best_sellers: d.includes("best-seller"),
    metadata: r
  };
}).filter(Boolean), Lt = (e, t, r, { topsortSlots: n, limit: a = bt.resultsPerPage } = {}) => {
  const o = t?.flatMap((f) => f.winners).filter(Boolean) || [];
  if (!e && o.length === 0) return;
  const s = Array.isArray(n) ? n.map((f) => Number(f)).filter(Boolean) : [], c = e?.response?.results?.filter((f) => !o.some((u) => u.id === f.data?.id)), d = {
    ...e?.response || {},
    results: c?.map((f) => ({
      ...f.data,
      id: f.data?.id || "",
      name: f.value || ""
    })) || []
  };
  return r !== void 0 ? rl(o, r).forEach((f, u) => {
    const p = s[u] - 1;
    d.results.splice(p, 0, f);
  }) : o.length > 0 && s.length && d.results?.length && s.forEach((f, u) => {
    const p = s[u] - 1;
    d.results.splice(p, 0, {
      id: u.toString(),
      name: "Loading..."
    });
  }), d.results = d.results?.slice(0, a), d;
}, nl = async ({ apiKey: e, slots: t, ...r } = {}) => {
  if (!e || !r.products?.ids?.length && !r.category && !r.searchQuery) return;
  const n = performance.now(), a = new to({ apiKey: e }), o = typeof t == "number" ? t : t?.length || 0;
  if (t)
    try {
      const s = await a.createAuction({ auctions: [{
        type: "listings",
        slots: o,
        ...r
      }] }), c = performance.now();
      return typeof window > "u" && console.log(`[topsort request] ${(c - n).toFixed(2)}ms`), s;
    } catch (s) {
      console.error("[topsort request]", s);
      return;
    }
}, ct = /* @__PURE__ */ new Map(), ol = (e) => {
  const t = `${e.apiKey}-${e.slots}-${JSON.stringify(e.category)}-${e.searchQuery ?? ""}`;
  return ct.has(t) || ct.set(t, nl(e)), ct.get(t);
}, Ft = (e) => {
  if (e?.apiKey)
    return (0, l.use)(ol(e));
}, ke = {
  page: 1,
  resultsPerPage: 24,
  sortBy: "relevance",
  sortOrder: "descending"
}, oe = Object.freeze({
  query: "q",
  page: "page",
  resultsPerPage: "numResults",
  filters: "filters",
  sortBy: "sortBy",
  sortOrder: "sortOrder",
  section: "section"
});
function Bt(e = !1) {
  const t = new URLSearchParams(window.location.search), r = {
    query: t.get(oe.query) ?? void 0,
    page: Number(t.get(oe.page)),
    resultsPerPage: Number(t.get(oe.resultsPerPage)),
    sortBy: t.get(oe.sortBy) ?? void 0,
    sortOrder: t.get(oe.sortOrder) ?? void 0,
    section: t.get(oe.section) ?? void 0
  };
  for (const [o, s] of Object.entries(ke)) (r[o] === s || !r[o]) && delete r[o];
  const n = {}, a = new RegExp(`^${oe.filters}\\[(.*)\\]`);
  return t.forEach((o, s) => {
    const c = s.match(a)?.[1];
    if (c && o) if (n[c]) Array.isArray(n[c]) ? n[c].push(o) : n[c] = [n[c], o];
    else {
      const d = o.split(",");
      n[c] = d.length > 1 ? d : o;
    }
  }), Object.keys(n).length > 0 && (r.filters = n), e ? {
    ...ke,
    ...r
  } : r;
}
var al = (e) => {
  const t = new URLSearchParams();
  for (const [r, n] of Object.entries(e))
    if (!(!n || n === ke[r])) {
      if (r === "filters") Object.entries(n).forEach(([a, o]) => {
        !o || o.length === 0 || t.set(`filters[${a}]`, o.toString());
      });
      else if (!["qsParam", "section"].includes(r)) {
        const a = oe[r];
        if (!a) continue;
        t.set(a, n.toString());
      }
    }
  return t;
}, ro = (e) => {
  const [t, r] = (0, l.useState)(e);
  return Bo("popstate", () => {
    r(Bt());
  }), {
    state: t,
    handleStateChange: (a) => {
      const o = {
        ...t,
        ...a
      };
      for (const c in o) o[c] === null && delete o[c];
      (0, l.startTransition)(() => {
        r(o);
      });
      const s = al(o);
      return window.history.pushState(o, "", `${window.location.pathname}?${s.toString()}`), o;
    }
  };
}, sl = (e) => ({
  "@context": "https://schema.org/",
  "@type": "ItemList",
  itemListElement: e.map((t, r) => ({
    "@type": "ListItem",
    position: r + 1,
    url: t.url ? `${window.location.origin}${t.url}` : void 0
  }))
}), no = (e) => {
  const t = "constructor-itemlist-schema", r = document.getElementById(t);
  let n;
  r ? n = r : (n = document.createElement("script"), n.id = t, n.type = "application/ld+json", document.head.appendChild(n));
  const a = sl(e);
  n.textContent = JSON.stringify(a);
}, oo = () => {
  const e = document.getElementById("constructor-itemlist-schema");
  e && e.remove();
}, il = (e, t) => {
  let r = {};
  return e && (r = {
    "data-cnstrc-browse": !0,
    "data-cnstrc-num-results": e.response?.total_num_results,
    "data-cnstrc-result-id": e.result_id
  }, "filterName" in t ? (r["data-cnstrc-filter-name"] = t.filterName, r["data-cnstrc-filter-value"] = t.filterValue) : "itemIds" in t && (r["data-cnstrc-item-ids"] = t.itemIds.join(","))), r;
}, ll = Bt(!0);
function cl({ cio: e, topsort: t = {}, config: r }) {
  const { state: n, handleStateChange: a } = ro({
    ...ke,
    ...e.requestParams,
    ...ll
  }), o = wt({
    ...e,
    requestParams: n
  });
  if (typeof window < "u" && "_cio_facetsort" in window && window._cio_facetsort && o?.response?.facets?.length) {
    const w = o.response.facets.filter((g) => g.name && !(g.name in window._cio_facetsort));
    Object.entries(window._cio_facetsort).forEach(([g, v]) => {
      const x = o.response.facets.find((S) => S.name === g);
      x && w.splice(v, 0, x);
    }), o.response.facets = w;
  }
  o?.response?.results && r?.whitelist && (o.response.facets = o.response.facets?.filter((w) => r.whitelist.includes(w.name)));
  const { reportEvent: s } = Mt(t), { handleBrowseClick: c } = $t(e.clientOptions), d = (w, g, v) => {
    g.metadata?.resolvedBidId && s({ clicks: [{
      id: crypto.randomUUID(),
      occurredAt: (/* @__PURE__ */ new Date()).toISOString(),
      opaqueUserId: localStorage.getItem("client_id") || crypto.randomUUID(),
      resolvedBidId: g.metadata.resolvedBidId,
      placement: {
        path: window.location.pathname,
        page: n.page,
        pageSize: n.resultsPerPage,
        position: v + 1,
        categoryIds: e.filterName === "group_id" ? [e.filterValue] : []
      }
    }] }), !(!e.filterName || !e.filterValue || !o?.response) && c(g, v, n, {
      filterName: e.filterName,
      filterValue: e.filterValue,
      result_id: o.result_id,
      request: o.request,
      response: o.response
    });
  }, f = [], u = o?.response?.facets?.find((w) => w.name === "current_category_int");
  u && u.options.length === 1 && f.push("current_category_int"), e.filterName && !["group_id", "items"].includes(e.filterName) && f.push(e.filterName);
  const p = Ft(t)?.results, m = p?.flatMap((w) => w.winners.map((g) => g.id)).filter(Boolean) || [], h = Ot(m, m.length > 0), b = r?.enable_browse_impression ?? !0 ? il(o, e) : {}, y = Lt(o, p, h, { topsortSlots: t?.slots });
  return (0, l.useEffect)(() => {
    y?.results?.length && typeof window < "u" && window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets == "function" && window.yotpoWidgetsContainer.initWidgets();
  }, [y?.results]), (0, l.useEffect)(() => (y?.results?.length && no(y?.results), () => {
    oo();
  }), [y?.results]), /* @__PURE__ */ (0, i.jsx)(Jn, {
    data: y,
    selectedFilters: Object.fromEntries(Object.entries(n.filters || {}).filter(([, w]) => w != null)),
    selectedSort: {
      sort_by: n.sortBy || "relevance",
      sort_order: n.sortOrder || "descending"
    },
    currentPage: n.page,
    resultsPerPage: n.resultsPerPage,
    onFilterChange: (w, g) => {
      a({ filters: {
        ...n.filters,
        [w]: g
      } });
    },
    onSortChange: (w) => a({
      sortBy: w.sort_by,
      sortOrder: w.sort_order
    }),
    onPageChange: (w) => a({ page: w }),
    onClearFilters: () => a({ filters: null }),
    onCardClick: d,
    onImpression: s,
    config: r,
    excludeFacets: f,
    autoExpandCount: r?.auto_expand_count,
    ...b
  });
}
function ul(e) {
  return /* @__PURE__ */ (0, i.jsx)(l.Suspense, {
    fallback: /* @__PURE__ */ (0, i.jsx)("div", {
      className: "hidden",
      children: "Loading..."
    }),
    children: /* @__PURE__ */ (0, i.jsx)(cl, { ...e })
  });
}
var dl = (e) => e ? {
  "data-cnstrc-search": !0,
  "data-cnstrc-result-id": e.result_id,
  "data-cnstrc-num-results": e.response.total_num_results
} : {}, dr = Bt(!0);
function fl({ cio: e, topsort: t, config: r }) {
  const { state: n, handleStateChange: a } = ro({
    ...ke,
    ...e.requestParams,
    ...dr,
    query: e.query || dr.query
  }), o = e.query || n.query || "", s = Lo({
    ...e,
    query: o,
    requestParams: n
  }, !!o), c = wt({
    clientOptions: e.clientOptions,
    requestParams: n,
    filterName: "group_id",
    filterValue: "all"
  }, !o), d = o ? s : c, { reportEvent: f } = Mt(t);
  (0, l.useEffect)(() => {
    s?.response && "redirect" in s.response && window.location.replace(s.response.redirect.data.url);
  }, [s?.response]), (0, l.useEffect)(() => {
    const v = document.getElementById("cio-autocomplete-0-input");
    v && (v.value = n.query || ""), n.query && Fo(n.query);
  }, [n.query]);
  const { handleSearchClick: u } = $t(e.clientOptions), p = (v, x) => {
    x.metadata?.resolvedBidId && f({ clicks: [{
      id: crypto.randomUUID(),
      occurredAt: (/* @__PURE__ */ new Date()).toISOString(),
      opaqueUserId: localStorage.getItem("client_id") || crypto.randomUUID(),
      resolvedBidId: x.metadata.resolvedBidId,
      placement: {
        path: window.location.pathname,
        searchQuery: n.query
      }
    }] }), u(x, n, {
      query: n.query || "",
      result_id: d?.result_id
    });
  }, m = Ft(t && o ? {
    ...t,
    searchQuery: o
  } : void 0)?.results, h = m?.flatMap((v) => v.winners.map((x) => x.id)).filter(Boolean) || [], b = Ot(h, h.length > 0), y = dl(d), w = d?.response && "redirect" in d.response, g = w ? void 0 : Lt(d, m || [], b, { topsortSlots: t?.slots });
  return (0, l.useEffect)(() => {
    g?.results?.length && typeof window < "u" && window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets == "function" && window.yotpoWidgetsContainer.initWidgets();
  }, [g?.results]), (0, l.useEffect)(() => (g?.results?.length && no(g?.results), () => {
    oo();
  }), [g?.results]), w ? null : /* @__PURE__ */ (0, i.jsx)(Jn, {
    data: g,
    selectedFilters: Object.fromEntries(Object.entries(n.filters || {}).filter(([, v]) => v != null)),
    selectedSort: {
      sort_by: n.sortBy || "relevance",
      sort_order: n.sortOrder || "descending"
    },
    currentPage: n.page,
    resultsPerPage: n.resultsPerPage,
    onFilterChange: (v, x) => {
      a({ filters: {
        ...n.filters,
        [v]: x
      } });
    },
    onSortChange: (v) => a({
      sortBy: v.sort_by,
      sortOrder: v.sort_order
    }),
    excludeFacets: e.excludeFacets,
    onPageChange: (v) => a({ page: v }),
    onClearFilters: () => a({ filters: null }),
    onCardClick: p,
    onImpression: f,
    config: r,
    ...y
  });
}
function ao(e) {
  return /* @__PURE__ */ (0, i.jsx)(l.Suspense, {
    fallback: /* @__PURE__ */ (0, i.jsx)("div", {
      className: "hidden",
      children: "Loading..."
    }),
    children: /* @__PURE__ */ (0, i.jsx)(fl, { ...e })
  });
}
var so = class extends mr {
  constructor(...e) {
    super(...e), Z(this, "apiKey", ""), Z(this, "version", void 0), Z(this, "cioOptions", void 0), Z(this, "sectionPreFilters", []), Z(this, "metafieldPreFilters", void 0), Z(this, "config", void 0);
  }
  async connectedCallback() {
    await super.connectedCallback(), this.apiKey = this.dataset.apiKey || "", this.version = this.dataset.version, this.cioOptions = this.getJson("cio-options"), this.sectionPreFilters = this.getJson("section-pre-filters") || [], this.metafieldPreFilters = this.getJson("metafield-pre-filters"), this.config = this.getJson("config");
  }
}, pl = class extends so {
  constructor(...e) {
    super(...e), Z(this, "categoryIds", []), Z(this, "productIds", []);
  }
  async connectedCallback() {
    await super.connectedCallback();
    const e = this.dataset.filterName || "group_id", t = this.dataset.filterValue || "all";
    this.categoryIds = this.parseJson(this.dataset.categoryIds) || [], this.productIds = this.parseJson(this.dataset.productIds) || [];
    const r = { ...this.cioOptions };
    let n = {
      filterName: e,
      filterValue: t
    }, a;
    const o = this.metafieldPreFilters?.pre_filters || [], s = this.metafieldPreFilters?.search_query || "";
    this.categoryIds.length > 0 ? this.categoryIds.length > 1 || s ? a = { or: this.categoryIds.map((m) => ({
      name: "current_category_int",
      value: m.toString()
    })) } : (n.filterName = "group_id", n.filterValue = this.categoryIds[0].toString()) : this.productIds.length > 0 && (n = { itemIds: this.productIds });
    const c = {
      apiKey: this.apiKey,
      version: this.version
    }, d = [...this.sectionPreFilters, ...o];
    d.length > 0 && a ? r.preFilterExpression = { and: [...d, a] } : d.length > 0 ? r.preFilterExpression = { and: d } : a && (r.preFilterExpression = a);
    const f = this.getJson("topsort-configuration");
    let u;
    if (f) {
      const m = this.categoryIds?.[0]?.toString();
      u = {
        apiKey: f.apiKey,
        slots: f.slots,
        ...m ? { category: { id: m } } : {}
      };
    }
    let p;
    s ? p = /* @__PURE__ */ (0, i.jsx)(ao, {
      cio: {
        clientOptions: c,
        requestParams: r,
        query: s
      },
      topsort: u,
      config: this.getJson("config")
    }) : p = /* @__PURE__ */ (0, i.jsx)(ul, {
      cio: {
        ...n,
        requestParams: r,
        clientOptions: c
      },
      topsort: u,
      config: this.getJson("config")
    }), (0, St.createRoot)(this).render(/* @__PURE__ */ (0, i.jsx)(vt, { children: p }));
  }
};
customElements.get("cio-browse") || customElements.define("cio-browse", pl);
var ml = class extends so {
  async connectedCallback() {
    await super.connectedCallback();
    const e = this.dataset.query || "", t = { ...this.cioOptions }, r = this.dataset.excludeFacets?.split(/,\s*/);
    this.sectionPreFilters.length > 0 && (t.preFilterExpression = { and: this.sectionPreFilters });
    const n = this.getJson("topsort-configuration");
    let a;
    n && (a = {
      apiKey: n.apiKey,
      slots: n.slots
    }), (0, St.createRoot)(this).render(/* @__PURE__ */ (0, i.jsx)(vt, { children: /* @__PURE__ */ (0, i.jsx)(ao, {
      cio: {
        clientOptions: {
          apiKey: this.apiKey,
          version: this.version
        },
        excludeFacets: r,
        requestParams: t,
        query: e
      },
      topsort: a,
      config: this.getJson("config")
    }) }));
  }
};
customElements.get("cio-search") || customElements.define("cio-search", ml);
var hl = (e) => e.result_id ? {
  "data-cnstrc-recommendations": !0,
  "data-cnstrc-recommendations-pod-id": e.podId,
  "data-cnstrc-result-id": e.result_id,
  "data-cnstrc-num-results": e.total_num_results,
  "data-cnstrc-recommendations-seed-items": Array.isArray(e.seedIds) && e.seedIds.length > 0 ? e.seedIds.join(",") : e.seedIds
} : {}, gl = ({ cio: e, topsort: t = {}, heading: r, topsortData: n, shopifyData: a, ...o }) => {
  const s = e?.requestParams?.itemIds || [], c = e && Array.isArray(s) && s.length > 0, d = $o(e, !c), f = wt({
    clientOptions: e?.clientOptions,
    itemIds: e?.requestParams?.itemIds || [],
    requestParams: e?.requestParams
  }, c), u = Array.isArray(s) && s.length > 0 ? f : d;
  u?.response.results && o.config?.filter_product_family && (u.response.results = u.response.results.filter((w, g, v) => w.data?.product_family_id ? v.findIndex((x) => x.data?.product_family_id === w.data?.product_family_id) === g : !0).slice(0, e?.requestParams?.numResults || 8));
  const { reportEvent: p } = Mt(t), m = Lt(u, n || [], a, { topsortSlots: t?.slots }), { handleRecommendationsClick: h } = $t(e?.clientOptions), b = (w, g, v) => {
    e && h(g, v, {
      pod_id: e.podId || "",
      response: u?.response,
      result_id: u?.result_id
    });
  };
  let y = {};
  return e?.podId && u && (y = hl({
    podId: e.podId,
    result_id: u.result_id || "",
    total_num_results: u.response?.total_num_results || 0,
    seedIds: e.requestParams?.itemIds
  })), /* @__PURE__ */ (0, i.jsx)(Ko, {
    ...o,
    ...y,
    heading: r || u?.response?.pod?.display_name,
    data: m?.results || [],
    onClick: b,
    onImpression: p,
    withCioAttributes: !!e?.podId
  });
};
function vl({ className: e }) {
  return /* @__PURE__ */ (0, i.jsx)("div", {
    className: `flex items-center justify-center p-8 ${e || ""}`,
    children: /* @__PURE__ */ (0, i.jsx)(Qa, { className: "size-8 bg-white animate-spin" })
  });
}
var wl = (e) => /* @__PURE__ */ (0, i.jsx)(l.Suspense, {
  fallback: /* @__PURE__ */ (0, i.jsx)(vl, {}),
  children: /* @__PURE__ */ (0, i.jsx)(gl, { ...e })
}), bl = ({ topsort: e = {}, ...t }) => {
  const r = Ft(e)?.results, n = r?.flatMap((o) => o.winners.map((s) => s.id)).filter(Boolean) || [], a = Ot(n, n.length > 0);
  return /* @__PURE__ */ (0, i.jsx)(wl, {
    ...t,
    topsort: e,
    topsortData: r,
    shopifyData: a
  });
}, yl = class extends mr {
  async connectedCallback() {
    await super.connectedCallback();
    const e = this.getJson("config"), t = this.getJson("topsort-configuration");
    let r;
    if (t) {
      const { categoryId: a, slots: o, page: s, ...c } = t;
      r = {
        ...c,
        page: {
          type: "PDP",
          pageId: location.pathname,
          ...s
        },
        slots: Array.isArray(o) ? o.map(Number) : o,
        category: a ? Array.isArray(a) ? { disjunctions: Array.from({ length: Math.ceil(a.length / 5) }, (d, f) => a.slice(f * 5, f * 5 + 5)) } : { id: a } : c.category
      };
    }
    const n = this.getJson("cio-configuration");
    if (!n && !r) {
      e?.is_design_mode && (this.innerHTML = "Constructor or Topsort data source is required");
      return;
    }
    if (!r && n && !n?.podId) {
      e?.is_design_mode && (this.innerHTML = "Pod ID is required for Constructor data source");
      return;
    }
    (0, St.createRoot)(this).render(/* @__PURE__ */ (0, i.jsx)(vt, { children: /* @__PURE__ */ (0, i.jsx)(bl, {
      heading: this.dataset.heading,
      subheading: this.dataset.subheading,
      headingTag: this.dataset.headingTag,
      carousel: {
        "data-autoplay": this.dataset.autoplay,
        "data-loop": this.dataset.loop,
        "data-drag-free": this.dataset.dragFree,
        "data-controls": this.dataset.controls,
        "data-axis": this.dataset.axis
      },
      config: e,
      cio: n,
      topsort: r,
      className: {
        heading: this.dataset.cssHeading || "",
        dots: this.dataset.cssDots || ""
      }
    }) }));
  }
};
customElements.get("cio-recommendations") || customElements.define("cio-recommendations", yl);
